<template>
	<div :class="['main', routeIsSearch == 1 ? 'mainSearch' : '']" style="width: 1180px;">
		<div style="width: 1137px;">
			<div class="topButton" v-if="routeIsSearch != 1">
				<a-button type="primary" @click="addRadar">添加监测仪</a-button>
				<!-- <a-button type="" @click="addCutBed">增减床位</a-button> -->
				<a-button class="aBtFocus" @click="clickBatchBedInfo()">批量添加监测仪</a-button>
				<a-button class="aBtFocus" :href="this.$store.state.baseUrl + '/excelModel/批量监测仪模板.xlsx'">批量监测仪模板下载</a-button>
				<a-button class="aBtFocus" @click="setInfo('批量')">批量设置卫生间设备</a-button>
				<div style="float:right;">
					<a-input-search v-model="keyWord" placeholder="请输入SN码" style="width: 155px" @search="onSearch" />
				</div>
				<a-modal v-model="exportShow" footer="" title="批量添加监测仪" :width="400">
					<a-form>
						<a-form-item>
							<!-- <a-upload name="file" :multiple="false" action="https://dev.qingleitech.com/api/v3/radar/uploadFile" @change="handleUpload"> -->
							<a-upload name="file" :multiple="false" action="api/v3/radar/uploadFile" @change="handleUpload">
								<div class="upFileWrap" v-if="upState == 0">
									<p class="fileLeftPath"></p>
									<a-button type="primary" v-if="upState == 0">选择文件</a-button>
								</div>
								<div class="upFileWrap" v-if="upState == 1 || upState == 2">
									<p class="fileLeftPath">{{ localFileName }}</p>
									<div class="sczIng" v-if="upState == 1">上传中</div>
									<a-button type="primary" v-if="upState == 2">重新上传</a-button>
								</div>
							</a-upload>

							<div class="xjDataWrap">
								<!-- 检测中 -->
								<div v-if="excelState == 0">
									<div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">正在校检 {{ localFileName }}</div>
									<div>共......条数据</div>
								</div>
								<!-- 检测完成 -->
								<div v-if="excelState == 1">
									<div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">检测完成 {{ localFileName }}</div>
									<div v-if="importExcelCode == 0">
										<!-- 数据正确 -->
										<div v-if="importExcelData.checkFlag">
											共检测到<span style="color:#1890FF;">
												{{ importExcelData.validNum }} </span>条有效数据
										</div>
										<!-- 数据错误 -->
										<div v-if="!importExcelData.checkFlag">
											<div>
												共检测到
												<span style="color:#1890FF;">{{
													importExcelData.totalNum
												}}</span>
												条数据，其中
												<span style="color:#1890FF;">{{
													importExcelData.validNum
												}}</span>
												条有效数据
											</div>
											<div v-if="importExcelData.bedInfoRepeatNum != 0">
												{{ importExcelData.bedInfoRepeatNum }}条SN码重复的数据，
												<span style="color:#FF8081">导入会覆盖原始数据</span>
											</div>
											<div v-if="importExcelData.invalidNum != 0">
												{{ importExcelData.invalidNum }}条SN码无效的数据
											</div>
											<div v-if="importExcelData.radarBindNum != 0">
												{{ importExcelData.radarBindNum }}条已被其他机构绑定
											</div>
											<div v-if="importExcelData.radarBindNum != 0">
												{{
													importExcelData.radarBindConsumerNum
												}}条已被C端机构绑定,<span class="colorff4d4f">导入会把关系拉到当前机构</span>
											</div>
											<div v-if="importExcelData.bedInfoFormatErrorNum != 0">
												{{
													importExcelData.bedInfoFormatErrorNum
												}}条格式错误数据
											</div>
											<div v-if="importExcelData.bedInfoRecordLimitNum != 0">
												{{
													importExcelData.bedInfoRecordLimitNum
												}}条SN码信息数量超限，录入同一个卫生间的用户信息多于5个
											</div>
											<div v-if="importExcelData.bedInfoAddToLimitNum">
												{{
													importExcelData.bedInfoAddToLimitNum
												}}条SN码的已录入&即将录入的信息总额超限，录入同一个卫生间的用户信息多于5个
											</div>
											<div v-if="importExcelData.bedInfoRecordFullNum">
												{{
													importExcelData.bedInfoRecordFullNum
												}}条SN码已录入信息满额，卫生间设备已经有5条用户信息，需要删除原信息才能继续录入
											</div>
										</div>
									</div>
									<!-- 模板错误 -->
									<div v-if="importExcelCode == 1" style="color:#FF4D4F">
										{{ isImportFalseMsg }}
									</div>
								</div>
							</div>
							<div class="aBtWrap" v-if="upState == 0" style="height:50px;"></div>
							<div class="aBtWrap" v-if="upState != 0">
								<a-button @click="exportShow = false">取消</a-button>
								<a-button class="ml10" type="primary" @click="downProblemData()"
									v-if="importExcelData && !importExcelData.checkFlag">下载问题数据</a-button>
								<a-button class="ml10" type="primary" @click="importExcel(true)" :loading="exLoading"
									v-if="excelState == 1" :disabled="importExcelCode == 1 ? true : false">确定导入</a-button>
							</div>
						</a-form-item>
					</a-form>
				</a-modal>
			</div>

			<div class="mb20" v-if="routeIsSearch == 1">
				关于"{{ keyWord }}"共搜索到
				<span class="color63B5FF">{{ total }}</span>
				条结果
				<router-link class="color63B5FF ml30 cursorPointer" to="./radarBed" tag="span">返回</router-link>
			</div>

			<div class="tableWrap">
				<a-table :columns="columns" :data-source="tableData" bordered :pagination="false" rowKey="id"
					v-if="tableData && tableData.length != 0">
					<template slot="radar" slot-scope="scope">
						<div class="radarData">
							<span>{{ scope.snCode }}</span>
							<div class="tableImg mr15" @click="deleteRadar(scope)"></div>
						</div>
					</template>
					<template slot="beds" slot-scope="scope">
						<div class="bedData">
							<a-cascader :default-value="scope.value" :options="selectDataList" placeholder="请选择"
								@change="onChange($event, scope)" style="width: 100%" />
						</div>
					</template>
					<template slot="info" slot-scope="scope">
						<div>
							<!-- 
                bedInfoStatus  0不显示 1录入(床设备，卫生间设备) 2查看、清空床位信息(床设备) 3-录入(禁用)
                fallRelStatus  0不显示 1关联卫生间(床设备) 2查看关联(床设备) 3查看(卫生间设备) 清空床位信息
                -->
							<!-- 卫生间设备 -->
							<div v-if="scope.type == 2">
								<a-button type="link" @click="checkInfo(scope)" v-if="scope.fallRelStatus == 3">
									查看
								</a-button>
								<a-button type="link" class="noCanLrTip" @click="inputInfo(scope)"
									:disabled="scope.bedInfoStatus == 3 ? true : false"
									v-if="scope.bedInfoStatus == 1 || scope.bedInfoStatus == 3">
									录入
									<div class="noCanLr" v-if="scope.bedInfoStatus == 3">
										每个卫生间设备最多录入5个用户信息，请先删除信息，才能继续录入
									</div>
								</a-button>
								<a-button type="link" @click="setInfo(scope)" :disabled="scope.isRadarOnline == 1 ? false : true"
									v-if="scope.isSetShow && scope.isRadarOnline == 1">
									设置
								</a-button>
								<a-button type="link" @click="oneKeyClearBtnClick(scope)">
									一键清空
								</a-button>

								<!-- <a-button type="link" @click="deleteInfo(scope)" v-if="scope.fallRelStatus == 3">
									清空信息
								</a-button> -->
								<a-popover title="温馨提示">
									<template slot="content">
										<p>C端已录入信息，只支持编辑，不能清空</p>
									</template>
									<a-button type="link" @click="deleteInfo(scope)"
										v-if="scope.fallRelStatus == 3 && scope.isClearBtnDisabled" style="color:rgba(191, 191, 191, 1)">
										清空信息
									</a-button>
								</a-popover>
								<a-button type="link" @click="deleteInfo(scope)"
									v-if="scope.bedInfoStatus == 3 && !scope.isClearBtnDisabled">
									清空信息
								</a-button>

								<a-popover title="温馨提示">
									<template slot="content">
										<p>当前设备不在线，在线后方可设置</p>
									</template>
									<a-button type="link" @click="setInfo(scope)" :disabled="scope.isRadarOnline == 1 ? false : true"
										v-if="scope.isSetShow && scope.isRadarOnline == 0">
										设置
									</a-button>
								</a-popover>
							</div>

							<!-- 床设备 -->
							<div v-if="scope.type == 1">
								<a-button type="link" @click="inputInfo(scope)" v-if="scope.bedInfoStatus == 1">
									录入
								</a-button>

								<a-button type="link" @click="checkInfo(scope)" v-if="scope.bedInfoStatus == 2">
									查看
								</a-button>

								<a-popover title="温馨提示">
									<template slot="content">
										<p>C端已录入信息，只支持编辑，不能清空</p>
									</template>
									<!-- <a-button type="link" @click="setInfo(scope)" :disabled="scope.isRadarOnline == 1 ? false : true"
                    v-if="scope.isSetShow && scope.isRadarOnline == 0">
                    设置
                  </a-button> -->
									<a-button type="link" v-if="scope.bedInfoStatus == 2 && scope.isClearBtnDisabled"
										style="color:rgba(191, 191, 191, 1)">
										清空信息
									</a-button>
								</a-popover>
								<a-button type="link" @click="deleteInfo(scope)"
									v-if="scope.bedInfoStatus == 2 && !scope.isClearBtnDisabled">
									清空信息
								</a-button>

								<a-button type="link" @click="clickReWC(scope, 2)" v-if="scope.fallRelStatus == 1">
									关联卫生间
								</a-button>
								<a-button type="link" @click="clickReWC(scope, 1)" v-if="scope.fallRelStatus == 2">
									查看关联卫生间
								</a-button>
								<a-button type="link" @click="clickRelWatch(scope, 2)" v-if="scope.watchRelStatus == 1">
									关联手表
								</a-button>
								<a-button type="link" @click="clickRelWatch(scope, 1)" v-if="scope.watchRelStatus == 2">
									查看关联手表
								</a-button>
								<a-button type="link" @click="oneKeyClearBtnClick(scope)">
									一键清空
								</a-button>
							</div>
						</div>
					</template>
					<template slot="fourG" slot-scope="scope">
						<!-- expirationDateStatus 套餐到期时间状态: 0-正常 1-即将过期(1个月) 2-已过期 3-套餐异常 4-无	 -->
						<div class="fourG_tr" v-if="scope.expirationDateStatus != 3 && scope.expirationDateStatus != 4">
							<!-- <div class="fourG_tr"> -->
							<div class="dqTime color262626" v-if="scope.expirationDateStatus == 0">{{ scope.expirationDate }}</div>
							<div class="dqTime colorFAAB62" v-if="scope.expirationDateStatus == 1">{{ scope.expirationDate }}</div>
							<div class="dqTime colorff4d4f" v-if="scope.expirationDateStatus == 2">{{ scope.expirationDate }}</div>
							<div class="dqTime color1890ff ml20">

								<el-popover placement="bottom" trigger="click" popper-class="xfWrap">
									<!-- <img class="qrDaSanJiao" src="../../assets/qrDaSanJiao.png"> -->
									<div>
										<div class="xfTit">用微信扫描二维码去操作</div>
										<div class="xfQrWrap">
											<img class="xfQrImg" :src="qrCode_baseUrl" />
										</div>
										<div class="xfTipWrap mt20">
											<div class="xfPointBlue"></div>
											<div class="xfTipsBlue">支付成功后请点击“刷新”查看最新到期日期</div>
										</div>
										<div class="xfTipTwo">
											<div>最长需要等待</div>
											<div style="color:#F1A75C;font-weight: bold;">5分钟</div>
											<div>最新到期时间才能生效哦</div>
										</div>
										<div class="xfLine"></div>
										<div class="xfTipWrap mt10">
											<div class="xfPointBlue"></div>
											<div class="xfTipsBlue">也可以联系您的销售人员进行批量续费</div>
										</div>
									</div>
									<div slot="reference" class="cursorPointer" v-if="scope.isRenewSwitch" @click="cli_xfBtn(scope)">续费
									</div>
								</el-popover>
							</div>
							<div class="dqRefresh" v-if="scope.isRefreshShow" @click="clc_refresh(scope)">刷新</div>
						</div>

						<div class="fourG_tr" v-if="scope.expirationDateStatus == 3">
							<img class="icon_notice_dImg" src="../../assets/icon_notice_d@2x.png">
							<div class="dqTime colorff4d4f">套餐异常，请联系清雷负责人</div>
						</div>

						<div class="fourG_tr" v-if="scope.expirationDateStatus == 4">
							<div class="dqTime colorBFBFBF">无</div>
						</div>


					</template>
				</a-table>
				<a-empty description="暂无内容哦" class="pt20 pb20" v-if="tableData && tableData.length == 0" />
			</div>
		</div>
		<a-pagination :pageSize="20" v-model="pageNum" :total="total" @change="pageChange" show-less-items
			style="text-align: center; margin-top: 20px" :hideOnSinglePage="true" />
		<!-- 清空床位信息 -->
		<a-modal v-model="unbound" :closable="false">
			即将解绑床位，是否要同时删除床位信息？
			<template slot="footer">
				<a-button @click="unboundCancel"> 取消 </a-button>
				<a-button @click="unboundBed"> 仅解绑 </a-button>
				<a-button type="primary" @click="unboundClear"> 删除床位信息 </a-button>
			</template>
		</a-modal>
		<!-- 录入查看床位 -->
		<a-modal v-model="formVisible" footer="" :width="1000" :title="formTitle" class="lrck_TanWrap">
			<div class="tanUserInfoWrap" style="border-bottom:0;margin-bottom: 20px;" v-if="whatType == 2">
				<div class="tanUlist" v-if="snCode">
					<div class="box">
						<div class="name">设备码</div>
						<div class="name2">{{ snCode }}</div>
					</div>
					<div class="box">
						<div class="name">监测位置</div>
						<div class="name2" style="width: 245px;">{{ bedName }}</div>
					</div>
					<div class="box">
						<div class="name">绑定手机号</div>
						<div class="name2">{{ bindMobilePhone }}</div>
					</div>
				</div>
			</div>
			<div v-for="(wcItem, wcIndex) in inputForm" :key="wcIndex">
				<div :class="wcIndex != 0 ? 'lrck_tableWrap' : ''" v-if="wcItem && wcItem.bicVo">
					<div class="tanUserInfoWrap">
						<div class="toiDelUser" v-if="isEditing && whatType == 2" @click="delInfo(wcIndex, wcItem)">
							<img class="icon_Del" src="../../assets/icon_trashCan_nor.png" alt="" />
							<div class="ml10 mr15">删除用户</div>
						</div>
						<div class="tanUlist" v-if="wcItem.snCode">
							<div class="box">
								<div class="name" v-if="whatType == 1">设备码</div>
								<div class="name" v-if="whatType == 2">关联设备码</div>
								<div class="name2">{{ wcItem.snCode }}</div>
							</div>
							<div class="box">
								<div class="name">监测位置</div>
								<div class="name2" style="width:245px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
									{{ wcItem.bedName }}
								</div>
							</div>
							<div class="box" v-if="wcItem.bindMobilePhone">
								<div class="name">绑定手机号</div>
								<div class="name2">{{ wcItem.bindMobilePhone }}</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">姓名</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.name || !isEditing">
									{{ wcItem.bicVo.name || wcItem.name }}
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing && !wcItem.bicVo.name">
									<el-input v-model="wcItem.name" placeholder="请输入姓名" size="medium"></el-input>
								</div> -->
								<div class="name2" v-if="!isEditing">
									{{ wcItem.bicVo.name || wcItem.name || "" }}
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing">
									<el-input v-model="wcItem.name" placeholder="请输入姓名" size="medium"></el-input>
								</div>
							</div>
							<div class="box">
								<div class="name">性别</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.sex" style="width:245px;">
									<div v-if="wcItem.bicVo.sex == 1">男</div>
									<div v-if="wcItem.bicVo.sex == 2">女</div>
									<div v-if="wcItem.bicVo.sex != 1 && wcItem.bicVo.sex != 2"></div>
								</div>
								<div class="name2" v-if="!wcItem.bicVo.sex && !isEditing" style="width:245px;">
									<div v-if="wcItem.sex == 1">男</div>
									<div v-if="wcItem.sex == 2">女</div>
									<div v-if="wcItem.sex != 1 && wcItem.sex != 2"></div>
								</div>
								<div class="name2 name2_input_w79 pl5" v-if="isEditing && !wcItem.bicVo.sex" style="width:245px;">
									<el-select v-model="wcItem.sex" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.gender" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div> -->
								<div class="name2" v-if="!isEditing" style="width:245px;">
									<div v-if="wcItem.sex == 1">男</div>
									<div v-if="wcItem.sex == 2">女</div>
									<div v-if="wcItem.sex != 1 && wcItem.sex != 2"></div>
								</div>
								<div class="name2 name2_input_w79 pl5" v-if="isEditing" style="width:245px;">
									<el-select v-model="wcItem.sex" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.gender" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
							<div class="box">
								<div class="name">年龄段</div>
								<!-- <div class="name2" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.age" :key="index">
										<div v-if="item.value == wcItem.ageGroup">
											{{ inputFormSelect.age[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w105 pl5" v-if="isEditing">
									<el-select v-model="wcItem.ageGroup" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.age" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div> -->
								<div class="name2" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.age" :key="index">
										<div v-if="item.value == wcItem.ageGroup">
											{{ inputFormSelect.age[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w105 pl5" v-if="isEditing">
									<el-select v-model="wcItem.ageGroup" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.age" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
						</div>

						<div class="tanUlist">
							<div class="box">
								<div class="name">出生日期</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.birthday">
									{{ wcItem.bicVo.birthday }}
								</div>
								<div class="name2" v-if="!wcItem.bicVo.birthday && !isEditing">
									{{ wcItem.birthday }}
								</div>
								<div class="name2 name2_input_w205 pl5 aloneInputCss" v-if="!wcItem.bicVo.birthday && isEditing"
									@click="cliBirthTan(wcIndex)">
									<a-popover v-if="wcIndex == nowOper_birth_index" v-model="showBirthday" trigger="click"
										placement="right">
										<template slot="content">
											<div :style="{
												width: '300px',
												border: '1px solid #d9d9d9',
												borderRadius: '4px',
											}">
												<a-calendar :defaultValue="$moment(wcItem.birthday, 'YYYY-MM-DD')"
													:value="$moment(wcItem.birthday, 'YYYY-MM-DD')" :fullscreen="false" @panelChange="panelChange"
													@select="changeDate" />
											</div>
										</template>
									</a-popover>
									<div>{{ wcItem.birthday }}</div> // 原版注释了
									<el-input v-model="wcItem.birthday" :disabled="true" placeholder="请选择出生日期" size="medium"></el-input>
									<a-icon class="ml15" type="close-circle" theme="twoTone" two-tone-color="#1890ff"
										@click.stop="clickBirChazi" v-if="wcItem.birthday" />
								</div> -->
								<div class="name2" v-if="!isEditing">
									{{ wcItem.birthday }}
								</div>
								<!-- <div class="name2 name2_input_w205 pl5 aloneInputCss" v-if="isEditing" @click="cliBirthTan(wcIndex)">
									<a-popover v-if="wcIndex == nowOper_birth_index" v-model="showBirthday" trigger="click"
										placement="right">
										<template slot="content">
											<div :style="{
												width: '300px',
												border: '1px solid #d9d9d9',
												borderRadius: '4px',
											}">
												<a-calendar :defaultValue="$moment(wcItem.birthday, 'YYYY-MM-DD')"
													:value="$moment(wcItem.birthday, 'YYYY-MM-DD')" :fullscreen="false" @panelChange="panelChange"
													@select="changeDate" />
											</div>
										</template>
									</a-popover>
									<div>{{ wcItem.birthday }}</div> // 原版注释了
									<el-input v-model="wcItem.birthday" :disabled="true" placeholder="请选择出生日期" size="medium"></el-input>
									<a-icon class="ml15" type="close-circle" theme="twoTone" two-tone-color="#1890ff"
										@click.stop="clickBirChazi" v-if="wcItem.birthday" />
								</div> -->
								<!-- 去掉  @click="cliBirthTan(wcIndex)" -->
								<div class="name2 name2_input_w205 pl5 aloneInputCss" v-if="isEditing" @click="cliBirthTan(wcIndex)">
									<!-- <a-date-picker v-model:value="wcItem.birthday" size="large" placeholder=" 请选择出生日期" style="width: 205px"
										format="YYYY-MM-DD" /> -->
									<a-popover v-if="wcIndex == nowOper_birth_index" v-model="showBirthday" trigger="click"
										placement="right">
										<template slot="content">
											<div :style="{
												width: '300px',
												border: '1px solid #d9d9d9',
												borderRadius: '4px',
											}">
												<a-calendar :defaultValue="$moment(wcItem.birthday, 'YYYY-MM-DD')"
													:value="$moment(wcItem.birthday, 'YYYY-MM-DD')" :fullscreen="false" @panelChange="panelChange"
													@select="changeDate"
													:validRange="[$moment('1800-01-01', 'YYYY-MM-DD'), $moment('2200-01-01', 'YYYY-MM-DD')]" />
											</div>
										</template>
									</a-popover>
									<!-- <div>{{ wcItem.birthday }}</div> // 原版注释了 -->
									<!-- <div>{{ wcItem.birthday || '请选择出生日期' }}</div> -->
									<el-input v-model="wcItem.birthday" :disabled="true" placeholder="请选择出生日期" size="medium"></el-input>
									<a-icon class="ml15" type="close-circle" theme="twoTone" two-tone-color="#1890ff"
										@click.stop="clickBirChazi" v-if="wcItem.birthday" />
									<div
										style="background-color: #FFFFFF00; width: 210px; height: 30px; position: absolute; z-index: 100000; top: 10px;">
									</div>
								</div>
							</div>
							<div class="box">
								<div class="name">身份证号</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.idCard" style="width:245px;">
									{{ wcItem.bicVo.idCard }}
								</div>
								<div class="name2" v-if="!wcItem.bicVo.idCard && !isEditing" style="width:245px;">
									{{ wcItem.idCard }}
								</div>

								<div class="name2 name2_input_w171 pl5" v-if="!wcItem.bicVo.idCard && isEditing" style="width:245px;">
									<el-input v-model="wcItem.idCard"></el-input>
								</div> -->
								<div class="name2" v-if="!isEditing" style="width:245px;">
									{{ wcItem.idCard }}
								</div>

								<div class="name2 name2_input_w171 pl5" v-if="isEditing" style="width:245px;">
									<el-input v-model="wcItem.idCard"></el-input>
								</div>
							</div>
							<div class="box">
								<div class="name">紧急联系人</div>
								<!-- <div class="name2 overhidFont" style="width:160px" :title="wcItem.bicVo.mobilePhone"
									v-if="wcItem.bicVo.mobilePhone">
									{{ wcItem.bicVo.mobilePhone }}
								</div>
								<div class="name2 overhidFont" style="width:160px" :title="wcItem.bicVo.mobilePhone"
									v-if="!wcItem.bicVo.mobilePhone && !isEditing">
									{{ wcItem.mobilePhone }}
								</div>
								<div class="name2 name2_input_w171 pl5" v-if="!wcItem.bicVo.mobilePhone && isEditing">
									<el-input v-model="wcItem.mobilePhone" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11"
										placeholder="请输入手机号" size="medium"></el-input>
								</div> -->
								<div class="name2 overhidFont" style="width:160px" :title="wcItem.mobilePhone" v-if="!isEditing">
									{{ wcItem.mobilePhone }}
								</div>
								<div class="name2 name2_input_w171 pl5" v-if="isEditing">
									<el-input v-model="wcItem.mobilePhoneChange" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11"
										placeholder="请输入手机号" size="medium"></el-input>
								</div>
							</div>
						</div>

						<div class="tanUlist">
							<div class="box">
								<div class="name">护理等级</div>
								<div class="name2" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.nurGrade" :key="index">
										<div v-if="item.value == wcItem.nursingLevel">
											{{ inputFormSelect.nurGrade[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing">
									<el-select v-model="wcItem.nursingLevel" placeholder="请选择护理等级" size="medium">
										<el-option v-for="item in inputFormSelect.nurGrade" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
							<div class="box">
								<div class="name">行动能力</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.actionAbility" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.actAbility" :key="index">
										<div v-if="item.value == wcItem.bicVo.actionAbility">
											{{ inputFormSelect.actAbility[index].label }}
										</div>
									</div>
								</div>

								<div class="name2" v-if="!wcItem.bicVo.actionAbility && !isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.actAbility" :key="index">
										<div v-if="item.value == wcItem.actionAbility">
											{{ inputFormSelect.actAbility[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w150 pl5" v-if="!wcItem.bicVo.actionAbility && isEditing"
									style="width:245px;">
									<el-select v-model="wcItem.actionAbility" placeholder="请选择行动能力" size="medium">
										<el-option v-for="item in inputFormSelect.actAbility" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div> -->
								<div class="name2" v-if="!isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.actAbility" :key="index">
										<div v-if="item.value == wcItem.actionAbility">
											{{ inputFormSelect.actAbility[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w150 pl5" v-if="isEditing" style="width:245px;">
									<el-select v-model="wcItem.actionAbility" placeholder="请选择行动能力" size="medium">
										<el-option v-for="item in inputFormSelect.actAbility" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
							<!-- 改版注释 - 小黄 - 删除 v-if="wcItem.bicVo.livingState != null" -->
							<div class="box">
								<div class="name">行为状态</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.livingState">
									<div v-for="(item, index) in inputFormSelect.living_state" :key="index">
										<div v-if="item.value == wcItem.bicVo.livingState">
											{{ inputFormSelect.living_state[index].label }}
										</div>
									</div>
								</div>
								<div class="name2" v-if="!wcItem.bicVo.livingState && !isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.living_state" :key="index">
										<div v-if="item.value == wcItem.livingState">
											{{ inputFormSelect.living_state[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w150 pl5" v-if="!wcItem.bicVo.livingState && isEditing"
									style="width:245px;">
									<el-select v-model="wcItem.livingState" placeholder="请选择行动能力" size="medium">
										<el-option v-for="item in inputFormSelect.living_state" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div> -->
								<div class="name2" v-if="!isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.living_state" :key="index">
										<div v-if="item.value == wcItem.livingState">
											{{ inputFormSelect.living_state[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w150 pl5" v-if="isEditing" style="width:245px;">
									<el-select v-model="wcItem.livingState" placeholder="请选择行为状态" size="medium" @change="actionStateSelectChange">
										<el-option v-for="item in inputFormSelect.living_state" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">呼吸</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.breath">
									<span v-for="(itemBreath, indexBreath) in wcItem.bicVo.breath" :key="indexBreath">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.breath" :key="index_inputFormSelect">
											<span v-if="itemBreath == item_inputFormSelect.value">
												<span v-if="wcItem.bicVo.breath.length == 1">{{
													item_inputFormSelect.label
												}}</span>
												<span v-if="wcItem.bicVo.breath.length > 1 &&
														indexBreath != wcItem.bicVo.breath.length - 1
														">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.bicVo.breath.length > 1 &&
													indexBreath == wcItem.bicVo.breath.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>

								<div class="name2" v-if="!wcItem.bicVo.breath && !isEditing">
									<span v-for="(itemBreath, indexBreath) in wcItem.breath" :key="indexBreath">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.breath" :key="index_inputFormSelect">
											<span v-if="itemBreath == item_inputFormSelect.value">
												<span v-if="wcItem.breath.length == 1">{{
													item_inputFormSelect.label
												}}</span>
												<span v-if="wcItem.breath.length > 1 &&
														indexBreath != wcItem.breath.length - 1
														">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.breath.length > 1 &&
													indexBreath == wcItem.breath.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="!wcItem.bicVo.breath && isEditing" style="width:500px;">
									<span v-for="(itemBreath, indexBreath) in wcItem.breath" :key="indexBreath">
										<el-select v-model="wcItem.breath[indexBreath]" placeholder="请选择呼吸问题" size="medium">
											<el-option v-for="item in inputFormSelect.breath" :key="item.value" :label="item.label"
												:value="item.value" style="width: 195px" />
										</el-select>
										&nbsp;
									</span>
									<img class="cursorPointer" src="../../assets/jia.png" style="width:18px;"
										v-if="wcItem.breath.length < 2" @click="deleteBreath(0, wcIndex)" />
									// <a-icon type="plus-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.breath.length < 2" @click="deleteBreath(0,wcIndex)" />
									&nbsp;
									<a-icon type="close-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.breath.length > 1"
										@click="deleteBreath(1, wcIndex)" />
								</div> -->
								<div class="name2" v-if="!isEditing">
									<span v-for="(itemBreath, indexBreath) in wcItem.breath" :key="indexBreath">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.breath" :key="index_inputFormSelect">
											<span v-if="itemBreath == item_inputFormSelect.value">
												<span v-if="wcItem.breath.length == 1">{{
													item_inputFormSelect.label
												}}</span>
												<span v-if="wcItem.breath.length > 1 &&
														indexBreath != wcItem.breath.length - 1
														">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.breath.length > 1 &&
													indexBreath == wcItem.breath.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing" style="width:500px;">
									<span v-for="(itemBreath, indexBreath) in wcItem.breath" :key="indexBreath">
										<el-select v-model="wcItem.breath[indexBreath]" placeholder="请选择呼吸问题" size="medium">
											<el-option v-for="item in inputFormSelect.breath" :key="item.value" :label="item.label"
												:value="item.value" style="width: 195px" />
										</el-select>
										&nbsp;
									</span>
									<img class="cursorPointer" src="../../assets/jia.png" style="width:18px;"
										v-if="wcItem.breath.length < 2" @click="deleteBreath(0, wcIndex)" />
									<!-- // <a-icon type="plus-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.breath.length < 2" @click="deleteBreath(0,wcIndex)" /> -->
									&nbsp;
									<a-icon type="close-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.breath.length > 1"
										@click="deleteBreath(1, wcIndex)" />
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">心脏</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.heart">
									<span v-for="(itemHeart, indexHeart) in wcItem.bicVo.heart" :key="indexHeart">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.heart" :key="index_inputFormSelect">
											<span v-if="itemHeart == item_inputFormSelect.value">
												<span v-if="wcItem.bicVo.heart.length == 1">{{
													item_inputFormSelect.label
												}}</span>
												<span v-if="wcItem.bicVo.heart.length > 1 &&
														indexHeart != wcItem.bicVo.heart.length - 1
														">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.bicVo.heart.length > 1 &&
													indexHeart == wcItem.bicVo.heart.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>

								<div class="name2" v-if="!wcItem.bicVo.heart && !isEditing">
									<span v-for="(itemHeart, indexHeart) in wcItem.heart" :key="indexHeart">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.heart" :key="index_inputFormSelect">
											<span v-if="itemHeart == item_inputFormSelect.value">
												<span v-if="wcItem.heart.length == 1">{{
													item_inputFormSelect.label
												}}</span>
												<span v-if="wcItem.heart.length > 1 &&
														indexHeart != wcItem.heart.length - 1
														">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.heart.length > 1 &&
													indexHeart == wcItem.heart.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="!wcItem.bicVo.heart && isEditing" style="width:500px;">
									<span v-for="(itemHeart, indexHeart) in wcItem.heart" :key="indexHeart">
										<el-select v-model="wcItem.heart[indexHeart]" placeholder="请选择心脏问题" size="medium">
											<el-option v-for="item in inputFormSelect.heart" :key="item.value" :label="item.label"
												:value="item.value" style="width: 195px" />
										</el-select>
										&nbsp;
									</span>
									<img class="cursorPointer" src="../../assets/jia.png" style="width:18px;" v-if="wcItem.heart.length < 2"
										@click="deleteHeart(0, wcIndex)" />
								 // <a-icon type="plus-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.heart.length < 2" @click="deleteHeart(0,wcIndex)" />
									&nbsp;
									<a-icon type="close-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.heart.length > 1"
										@click="deleteHeart(1, wcIndex)" />
								</div> -->
								<div class="name2" v-if="!isEditing">
									<span v-for="(itemHeart, indexHeart) in wcItem.heart" :key="indexHeart">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.heart" :key="index_inputFormSelect">
											<span v-if="itemHeart == item_inputFormSelect.value">
												<span v-if="wcItem.heart.length == 1">{{
													item_inputFormSelect.label
												}}</span>
												<span v-if="wcItem.heart.length > 1 &&
														indexHeart != wcItem.heart.length - 1
														">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.heart.length > 1 &&
													indexHeart == wcItem.heart.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing" style="width:500px;">
									<span v-for="(itemHeart, indexHeart) in wcItem.heart" :key="indexHeart">
										<el-select v-model="wcItem.heart[indexHeart]" placeholder="请选择心脏问题" size="medium">
											<el-option v-for="item in inputFormSelect.heart" :key="item.value" :label="item.label"
												:value="item.value" style="width: 195px" />
										</el-select>
										&nbsp;
									</span>
									<img class="cursorPointer" src="../../assets/jia.png" style="width:18px;" v-if="wcItem.heart.length < 2"
										@click="deleteHeart(0, wcIndex)" />
									<!-- // <a-icon type="plus-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.heart.length < 2" @click="deleteHeart(0,wcIndex)" /> -->
									&nbsp;
									<a-icon type="close-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.heart.length > 1"
										@click="deleteHeart(1, wcIndex)" />
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">睡眠状况</div>
							</div>
							<div style="background:#f0f0f0;width:calc(100% - 82px);height:100%;"></div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">是否失眠</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.insomnia">
									<div v-for="(item, index) in inputFormSelect.insomnia" :key="index">
										<div v-if="item.value == wcItem.bicVo.insomnia">
											{{ inputFormSelect.insomnia[index].label }}
										</div>
									</div>
								</div>

								<div class="name2" v-if="!wcItem.bicVo.heart && !isEditing">
									<div v-for="(item, index) in inputFormSelect.insomnia" :key="index">
										<div v-if="item.value == wcItem.insomnia">
											{{ inputFormSelect.insomnia[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="!wcItem.bicVo.heart && isEditing">
									<el-select v-model="wcItem.insomnia" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.insomnia" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div> -->
								<div class="name2" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.insomnia" :key="index">
										<div v-if="item.value == wcItem.insomnia">
											{{ inputFormSelect.insomnia[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing">
									<el-select v-model="wcItem.insomnia" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.insomnia" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
							<div class="box">
								<div class="name">是否打呼噜</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.snore" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.snore" :key="index">
										<div v-if="item.value == wcItem.bicVo.snore">
											{{ inputFormSelect.snore[index].label }}
										</div>
									</div>
								</div>

								<div class="name2" v-if="!wcItem.bicVo.snore && !isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.snore" :key="index">
										<div v-if="item.value == wcItem.snore">
											{{ inputFormSelect.snore[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w79 pl5" v-if="!wcItem.bicVo.snore && isEditing" style="width:245px;">
									<el-select v-model="wcItem.snore" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.snore" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div> -->
								<div class="name2" v-if="!isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.snore" :key="index">
										<div v-if="item.value == wcItem.snore">
											{{ inputFormSelect.snore[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w79 pl5" v-if="isEditing" style="width:245px;">
									<el-select v-model="wcItem.snore" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.snore" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
							<div class="box">
								<div class="name">起夜频次</div>
								<div class="name2" v-if="!isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.night_frequency" :key="index">
										<div v-if="item.value == wcItem.nightFrequency">
											{{ inputFormSelect.night_frequency[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w79 pl5" v-if="isEditing" style="width:245px;">
									<el-select v-model="wcItem.nightFrequency" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.night_frequency" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name" style="width:166px;">
									已知睡眠呼吸障碍疾病
								</div>
								<!-- <div class="name2" v-if="wcItem.bicVo.sleepDisorderedBreathing">
									<span v-for="(itemSdb, indexSdb) in wcItem.bicVo
										.sleepDisorderedBreathing" :key="indexSdb">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.sleepDisorderedBreathing" :key="index_inputFormSelect">
											<span v-if="itemSdb == item_inputFormSelect.value">
												<span v-if="wcItem.bicVo.sleepDisorderedBreathing.length == 1
													">{{ item_inputFormSelect.label }}</span>
												<span v-if="wcItem.bicVo.sleepDisorderedBreathing.length > 1 &&
													indexSdb !=
													wcItem.bicVo.sleepDisorderedBreathing.length - 1
													">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.bicVo.sleepDisorderedBreathing.length > 1 &&
													indexSdb ==
													wcItem.bicVo.sleepDisorderedBreathing.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>
								<div class="name2" v-if="!wcItem.bicVo.sleepDisorderedBreathing && !isEditing">
									<span v-for="(itemSdb,
										indexSdb) in wcItem.sleepDisorderedBreathing" :key="indexSdb">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.sleepDisorderedBreathing" :key="index_inputFormSelect">
											<span v-if="itemSdb == item_inputFormSelect.value">
												<span v-if="wcItem.sleepDisorderedBreathing.length == 1">{{ item_inputFormSelect.label }}</span>
												<span v-if="wcItem.sleepDisorderedBreathing.length > 1 &&
													indexSdb !=
													wcItem.sleepDisorderedBreathing.length - 1
													">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.sleepDisorderedBreathing.length > 1 &&
													indexSdb ==
													wcItem.sleepDisorderedBreathing.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>
								// <div class="name2 name2_input_w205 pl5" v-if="isEditing">
								<div class="pl5" v-if="!wcItem.bicVo.sleepDisorderedBreathing && isEditing">
									<el-checkbox-group v-model="wcItem.sleepDisorderedBreathing">
										<el-checkbox label="1">呼吸暂停</el-checkbox>
										<span style="padding: 0 30px 0 0">
											<el-checkbox label="2">慢阻肺</el-checkbox>
										</span>
										<el-checkbox label="3">低通气</el-checkbox>
									</el-checkbox-group>
								</div> -->
								<div class="name2" v-if="!isEditing">
									<span v-for="(itemSdb,
										indexSdb) in wcItem.sleepDisorderedBreathing" :key="indexSdb">
										<span v-for="(item_inputFormSelect,
											index_inputFormSelect) in inputFormSelect.sleepDisorderedBreathing" :key="index_inputFormSelect">
											<span v-if="itemSdb == item_inputFormSelect.value">
												<span v-if="wcItem.sleepDisorderedBreathing.length == 1">{{ item_inputFormSelect.label }}</span>
												<span v-if="wcItem.sleepDisorderedBreathing.length > 1 &&
													indexSdb !=
													wcItem.sleepDisorderedBreathing.length - 1
													">{{ item_inputFormSelect.label }}、</span>
												<span v-if="wcItem.sleepDisorderedBreathing.length > 1 &&
													indexSdb ==
													wcItem.sleepDisorderedBreathing.length - 1
													">{{ item_inputFormSelect.label }}</span>
											</span>
										</span>
									</span>
								</div>
								<!-- <div class="name2 name2_input_w205 pl5" v-if="isEditing"> -->
								<div class="pl5" v-if="isEditing">
									<el-checkbox-group v-model="wcItem.sleepDisorderedBreathing">
										<el-checkbox label="1">呼吸暂停</el-checkbox>
										<span style="padding: 0 30px 0 0">
											<el-checkbox label="2">慢阻肺</el-checkbox>
										</span>
										<el-checkbox label="3">低通气</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">跌倒史</div>
								<div class="name2" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.fallHistory" :key="index">
										<div v-if="item.value == wcItem.fallHistory">
											{{ inputFormSelect.fallHistory[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing">
									<el-select v-model="wcItem.fallHistory" placeholder="请选择跌倒史" size="medium">
										<el-option v-for="item in inputFormSelect.fallHistory" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
							<div class="box">
								<div class="name" style="width:138px;">有超过一个医学判断</div>
								<div class="name2" v-if="!isEditing" style="width:245px;">
									<div v-for="(item, index) in inputFormSelect.medicalDiagnosis" :key="index">
										<div v-if="item.value == wcItem.medicalDiagnosis">
											{{ inputFormSelect.medicalDiagnosis[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w79 pl5" v-if="isEditing" style="width:245px;">
									<el-select v-model="wcItem.medicalDiagnosis" placeholder="" size="medium">
										<el-option v-for="item in inputFormSelect.medicalDiagnosis" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name" style="width:208px;">
									静脉输液/置管/使用特殊药物
								</div>
								<div class="name2" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.infusion" :key="index">
										<div v-if="item.value == wcItem.infusion">
											{{ inputFormSelect.infusion[index].label }}
										</div>
									</div>
								</div>
								<div style="margin-left: 5px;" v-if="isEditing">
									<el-select v-model="wcItem.infusion" placeholder="请选择静脉输液/置管/使用特殊药物" size="medium"
										style="width: 280px;">
										<el-option v-for="item in inputFormSelect.infusion" :key="item.value" :label="item.label"
											:value="item.value" style="width: 280px" />
									</el-select>
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">步态</div>
								<div class="name2" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.gait" :key="index">
										<div v-if="item.value == wcItem.gait">
											{{ inputFormSelect.gait[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w205 pl5" v-if="isEditing">
									<el-select v-model="wcItem.gait" placeholder="请选择步态" size="medium">
										<el-option v-for="item in inputFormSelect.gait" :key="item.value" :label="item.label"
											:value="item.value" style="width: 195px" />
									</el-select>
								</div>
							</div>
							<div class="box">
								<div class="name">认知状态</div>
								<div class="name2" style="width:340px;" v-if="!isEditing">
									<div v-for="(item, index) in inputFormSelect.cognitiveState" :key="index">
										<div v-if="item.value == wcItem.cognitiveState">
											{{ inputFormSelect.cognitiveState[index].label }}
										</div>
									</div>
								</div>
								<div class="name2 name2_input_w340 pl5" v-if="isEditing">
									<el-select v-model="wcItem.cognitiveState" placeholder="请选择认知状态" size="medium">
										<el-option v-for="item in inputFormSelect.cognitiveState" :key="item.value" :label="item.label"
											:value="item.value" style="width: 340px" />
									</el-select>
								</div>
							</div>
						</div>
						<div class="tanUlist">
							<div class="box">
								<div class="name">备注</div>
								<div class="name2" style="width:860px;overflow: auto;white-space: nowrap;" v-if="!isEditing">
									{{ wcItem.remarks }}
								</div>
								<div class="name2 name2_input_w860 pl5" v-if="isEditing">
									<el-input v-model="wcItem.remarks" placeholder="可备注长者的其他信息" size="medium"></el-input>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="toiAddUser mt5" v-if="whatType == 2 && isEditing && inputForm.length < 5" @click="cli_toiAddUser()">
				<!-- <a-icon type="plus-circle" theme="twoTone" two-tone-color="#1890ff" /> -->
				<img class="" src="../../assets/jia.png" />
				<div class="ml10">增加一个用户</div>
			</div>
			<div class="clear mt20">
				<div style="float: right">
					<el-button v-if="!isEditing" @click="onEdit()">编辑</el-button>
					<el-button v-if="!isEditing" type="primary" @click="formVisible = false">关闭</el-button>
					<div v-if="isEditing">
						<!-- <el-button
              type="primary"
              v-show="!formIsEmpty() && inputForm.name != ''"
              @click="onSubmit"
              >确定</el-button
            >
            <el-button
              disabled
              v-show="formIsEmpty() || inputForm.name == ''"
              @click="onSubmit"
              >确定</el-button
            > -->
						<el-button @click="formVisible = false">关闭</el-button>
						<el-button type="primary" @click="onSubmitNew">确定</el-button>
					</div>
				</div>
			</div>
		</a-modal>
		<!-- 设置弹窗 -->
		<a-modal v-model="set_formVisible" footer="" :width="900" :title="set_formTitle">
			<el-form>
				<div>
					<!-- 批量独有树形数据 -->
					<div v-if="set_formType == 2">
						<a-tree-select v-if="treeDatas.length > 0" v-model="valueSn" style="width: 50%" :tree-data="treeDatas"
							tree-checkable :treeDefaultExpandAll="true" :replace-fields="{ value2: 'valueSn', value: 'id' }"
							:show-checked-strategy="treeStrategy" placeholder="请点击选择想要添加的卫生间"
							:dropdown-style="{ maxHeight: '450px', overflow: 'auto' }" @change="onSelect" />
						<div class="sxTipRed" v-if="set_formType == 2">
							注意：不在线的设备不能设置
						</div>
					</div>
				</div>
				<div class="setFoData">
					<div class="slist">
						<p class="leftTit">设备开关</p>
					</div>
					<div class="slist">
						<p class="leftTit">存在灯</p>
						<div class="btWrap">
							<el-switch v-model="fallExistLamp" active-color="#1890FF" inactive-color="#BFBFBF" active-text="开"
								inactive-text="关">
							</el-switch>
						</div>
						<p class="leftTit">跌倒灯</p>
						<div class="btWrap">
							<el-switch v-model="fallLamp" active-color="#1890FF" inactive-color="#BFBFBF" active-text="开"
								inactive-text="关">
							</el-switch>
						</div>
						<p class="leftTit leftTit2">设备网络灯</p>
						<div class="btWrap">
							<el-switch v-model="fallNetLamp" active-color="#1890FF" inactive-color="#BFBFBF" active-text="开"
								inactive-text="关">
							</el-switch>
						</div>
					</div>
					<div class="slist">
						<p class="leftTit">设备配置</p>
					</div>
					<div class="slist bgfff">
						<p class="leftTit">监测高度</p>
						<div class="bbWrap">
							<input type="text" :class="['input1', fallMonhTip ? 'input1Red' : '']" v-model="fallMonh"
								onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" max="3" min="2.1" />
							<div class="p1">米</div>
							<div class="p1 colorBFBFBF">
								仅支持设置2.1~3.0米，最多支持两位小数
							</div>
							<div class="p1 colorff4d4f" v-if="fallMonhTip">
								请输入有效值范围内的数值
							</div>
						</div>
					</div>
					<div class="slist bgfff">
						<p class="leftTit">报警时间</p>
						<div class="bbWrap">
							<input type="text" :class="['input1', fallAlatTip ? 'input1Red' : '']" v-model="fallAlat"
								onkeyup="value=value.replace(/^\D*(\d*(?:\d{0,2})?).*$/g, '$1')" />
							<div class="p1">秒</div>
							<div class="p1 colorBFBFBF">
								仅支持设置10~240秒，仅支持整数
								(建议演示时设置10秒，使用时设置180秒)
							</div>
							<div class="p1 colorff4d4f" v-if="fallAlatTip">
								请输入有效值范围内的数值
							</div>
						</div>
					</div>
				</div>
				<div style="margin-top:20px;text-align: right;">
					<el-button @click="set_formVisible = false">关闭</el-button>
					<el-button type="primary" @click="set_onSubmit">确定</el-button>
				</div>
			</el-form>
		</a-modal>
		<!-- 设置弹框中点确定后显示设置中弹窗 -->
		<a-modal v-model="set_formVisible_ing" footer="" :width="400" title="">
			<div class="pt50">
				正在设置中，请稍候<span style="color:#63B5FF;">{{ countDown }}</span>s ...
			</div>
			<div class="pt20 pb50">注意：请勿关闭弹窗，否则无法收到设置结果</div>
		</a-modal>
		<!-- 设置弹框中点确定后显示设置中弹窗 -->
		<a-modal v-model="set_formVisible_plSucces" footer="" :width="400" title="">
			<!-- 成功 -->
			<div class="pt50" style="display:flex;" v-if="plResultData.successCount === plResultData.total">
				<img class="imgIconTK mr10" src="../../assets/check-circle-fill2.png" alt="" />
				<div>
					共
					<span style="color:#63B5FF;">{{ plResultData.successCount }}</span>
					台设备全部设置成功
				</div>
			</div>
			<!-- 失败 -->
			<div class="pt50" style="display:flex;" v-if="plResultData.successCount != plResultData.total">
				<img class="imgIconTK mr10" src="../../assets/iconOrangeAlarm.png" alt="" />
				<div>
					<div>
						设置成功
						<span style="color:#63B5FF;">{{ plResultData.successCount }}</span>
						台 设置失败
						<span style="color:#FF9C9D;">{{ plResultData.failCount }}</span>
						台
					</div>
					<div class="">失败的{{ plResultData.failCount }}台信息如下：</div>
					<div>
						<!-- <div class="" :key="index" v-for="(item,index) in plResultData.failList">{{item}}（卫生间）</div> -->
						<div class="" :key="index" v-for="(item, index) in plResultData.failList">
							{{ item.name }} - {{ item.snCodeName }}
						</div>
					</div>
				</div>
			</div>

			<div style="margin-top:20px;text-align: right;" v-if="this.plResultData.successCount == this.plResultData.total">
				<el-button type="primary" @click="set_onSubmit_succ">我知道了</el-button>
			</div>
			<div style="margin-top:20px;text-align: right;" v-if="this.plResultData.successCount != this.plResultData.total">
				<el-button type="primary" @click="set_onSubmit_succ">关闭</el-button>
				<el-button type="primary" @click="set_onSubmit_goSet">继续设置</el-button>
			</div>
		</a-modal>

		<!-- 关联卫生间弹窗 -->
		<a-modal v-model="relateWC" footer="" :width="500" :title="relateWC_Title">
			<el-form>
				<div class="watchRelateModal relateWCModal">
					<a-cascader :value="relateWC_treeData_value_Sel_Next" :default-value="relateWC_treeData_value"
						:options="relateWC_treeData" placeholder="点击选择需要关联的设备" @change="change_relateWC($event)" />

					<div class="watchRelateFooter">
						<a-button @click="relateWC = false">关闭</a-button>
					<!-- 关联卫生间relateWcType2 -->
						<a-button type="primary" @click="gl_relateWC" v-if="relateWcType == 2">关联</a-button>
					<!-- 查看关联relateWcType1 -->
						<a-button type="primary" @click="click_gl_Tan_Sure" v-if="relateWcType == 1">确定</a-button>
					</div>
				</div>
			</el-form>
		</a-modal>
		<!-- 关联卫生间弹窗内删除弹窗 -->
		<a-modal title="" :width="300" :visible="del_relateWC_Tan" :footer="null" :closable="false" size="large">
			<p class="delTips">
				<a-icon type="exclamation-circle" />
				确定要取消关联吗？
			</p>
			<div class="delBtn">
				<a-button style="margin-right: 10px" @click="del_relateWC_Tan_Cancel">取消</a-button>
				<a-button type="primary" @click="radarFall" :loading="loading">确定</a-button>
			</div>
		</a-modal>

		<!-- 关联手表弹窗 -->
		<a-modal :visible="relateWatchVisible" :footer="null" :width="500" :title="relateWatchTitle"
			@cancel="closeRelateWatchDialog">
			<div class="watchRelateModal">
				<div class="watchRelateLabel">手表sn</div>
				<a-input v-model="relateWatchValue" :allowClear="true"
					:class="['watchRelateInput', relateWatchError ? 'watchRelateInputError' : '']"
					placeholder="请输入要关联的手表sn" />
				<div class="watchRelateError">{{ relateWatchError }}</div>
				<div class="watchRelateFooter">
					<a-button @click="closeRelateWatchDialog">取消</a-button>
					<a-button type="primary" @click="submitRelateWatch" :loading="relateWatchLoading">确定</a-button>
				</div>
			</div>
		</a-modal>

		<a-modal title="添加监测仪" v-model="addRadarPopup" :width="400" @cancel="addRadarPopup = false" :footer="null">
			<div class="radarTanWrap">
				<input :class="['inputList', item.inputListBorRed ? 'inputListBorRed' : '']" type="text" placeholder="请输入监测仪SN码"
					oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" :key="index" v-for="(item, index) in radarSnList"
					v-model="item.snCode" />
				<div class="addJcy" @click="cliAddJcy()">
					<img class="jiaImg" src="../../assets/jia.png" alt="" />
					<div>一个监测仪</div>
				</div>
			</div>
			<div class="radarBtn">
				<a-button style="margin-right: 10px" @click="addRadarPopup = false">取消</a-button>
				<a-button type="primary" @click="addRadarOk" :loading="loading">添加</a-button>
			</div>
		</a-modal>
		<!-- 添加监测仪后反馈弹窗web3.0 -->
		<a-modal v-model="addRadarFeedback" footer="" :width="400" title="">
			<div class="pt50" style="display:flex;" v-if="v3_radarData">
				<img class="imgIconTK mr10" src="../../assets/iconOrangeAlarm.png" alt="" />
				<div>
					<div>
						添加成功
						<span style="color:#63B5FF;">{{ v3_radarData.succNum }}</span>
						台,添加失败
						<span style="color:#FF9C9D;">{{ v3_radarData.failNum }}</span>
						台,失败原因如下：
					</div>
					<div v-if="v3_radarData.noExist.num != 0">
						有以下
						<span style="color:#63B5FF;">{{ v3_radarData.noExist.num }}</span>
						个SN码不存在：
						<div style="display:flex;flex-wrap: wrap;">
							<div :key="index" v-for="(item, index) in v3_radarData.noExist.snCodeList">
								<div v-if="v3_radarData.noExist.snCodeList.length == 1">
									{{ item }}
								</div>
								<div v-if="v3_radarData.noExist.snCodeList.length > 1 &&
									index != v3_radarData.noExist.snCodeList.length - 1
									">
									{{ item }}、
								</div>
								<div v-if="v3_radarData.noExist.snCodeList.length > 1 &&
									index == v3_radarData.noExist.snCodeList.length - 1
									">
									{{ item }}
								</div>
							</div>
						</div>
					</div>
					<div v-if="v3_radarData.bindList.failNum != 0">
						<div :key="index" v-for="(item, index) in v3_radarData.bindList">
							有以下
							<span style="color:#63B5FF;">{{ item.num }}</span>
							个SN码已绑定在{{ item.tenant }}
							<span v-if="item.tenant == 'C端用户'">，</span>
							<span v-if="item.tenant == 'C端用户'" style="color: #FF8081;">继续添加会把关系拉到当前机构</span>
							：
							<div style="display:flex;flex-wrap: wrap;">
								<div :key="index2" v-for="(item2, index2) in item.snCodeList">
									<div v-if="item.snCodeList.length == 1">{{ item2 }}</div>
									<div v-if="item.snCodeList.length > 1 &&
										index2 != item.snCodeList.length - 1
										">
										{{ item2 }}、
									</div>
									<div v-if="item.snCodeList.length > 1 &&
										index2 == item.snCodeList.length - 1
										">
										{{ item2 }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- <div style="margin-top:20px;text-align: right;" v-if="this.plResultData.successCount == this.plResultData.total">
        <el-button type="primary" @click="set_onSubmit_succ">我知道了</el-button>
      </div> -->
			<div style="margin-top:20px;text-align: right;">
				<el-button @click="addRadarFeedback = false">关闭</el-button>
				<el-button type="primary" @click="cli_goAddRadar()">继续添加</el-button>
			</div>
		</a-modal>
		<!-- 删除弹窗 -->
		<a-modal title="" :width="400" v-model="delTimePopup" footer="">
			<p class="delTips pt50">
				<a-icon type="exclamation-circle" />
				{{ deleteRadarTip }}
			</p>
			<div style="margin-top:20px;text-align: right;">
				<el-button @click="delTimePopup = false">取消</el-button>
				<el-button type="primary" @click="delTimeOk">删除</el-button>
			</div>
		</a-modal>
		<!-- 清空信息弹窗 -->
		<a-modal title="" :width="400" v-model="emptyInfoPopup" footer="">
			<p class="delTips pt50">
				<a-icon type="exclamation-circle" />
				{{ deleteRadarTip }}
			</p>
			<div style="margin-top:20px;text-align: right;">
				<el-button @click="emptyInfoPopup = false">取消</el-button>
				<el-button type="primary" @click="deleteInputInfo">清空</el-button>
			</div>
		</a-modal>
		<!-- 删除用户，清空用户信息弹窗 -->
		<a-modal title="" :width="400" v-model="delInfoPopup" footer="">
			<p class="delTips pt50">
				<a-icon type="exclamation-circle" />
				{{ deleteRadarTip }}
			</p>
			<div style="margin-top:20px;text-align: right;">
				<el-button @click="delInfoPopup = false">取消</el-button>
				<el-button type="primary" @click="deleteToilet">删除</el-button>
			</div>
		</a-modal>

		<!-- 一键清空弹窗 -->
		<a-modal title="注意" :width="400" v-model="isShowOneKeyClearAlert" footer="">
			<div class="delTips" style="display: flex;">
				<div style="">
					<a-icon type="exclamation-circle" />
				</div>
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #262626; line-height: 20px;">即将清空设备所有数据，清空后不可恢复，确定要清  空吗？</div>
			</div>
			<div style="margin-top:20px;text-align: right;">
				<el-button @click="isShowOneKeyClearAlert = false">取消</el-button>
				<el-button type="primary" @click="oneKeyClearClick()">清空</el-button>
			</div>
		</a-modal>
		<!-- 行为状态特殊选择的二次弹窗 -->
		<a-modal title="温馨提示" :width="400" :visible="isShowTipAlertWqsn" :maskClosable="false" :footer="null"
			@cancel="setSpecialStateAlertCancelClick">
			<div style="display: block; align-items: center; margin-top: 10px; margin-bottom: 20px;">
				<img style="width: 16px; height: 16px; display: inline; margin-right: 5px; margin-top: -2px;" src="./../../assets/icon_alert_warning.png" alt="" />
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px; display: inline;">设置成“完全失能”后，老人的监测时段会自动升级为24小时，离床报警的时长为2分30秒，这是我们建议最适合完全失能老人的设置，确定设置吗？</div>
			</div>
			<div class="addBtn toitet-btn" style="margin-left: 210px;">
				<a-button style="margin-right: 10px" @click="setSpecialStateAlertCancelClick">取消</a-button>
				<a-button type="primary" @click="setSpecialStateAlertSureClick">确定</a-button>
			</div>
		</a-modal>

	</div>
</template>

<script>
const columns = [
	{
		title: '监测仪SN码',
		width: '476px',
		align: 'center',
		scopedSlots: { customRender: 'radar' },
	},
	// {
	//   title: "监测床位",
	//   width: "35%",
	//   align: "center",
	//   scopedSlots: { customRender: "beds" },
	// },
	{
		title: '设备信息',
		width: '420px',
		align: 'center',
		scopedSlots: { customRender: 'info' },
	},
	{
		title: '4G套餐情况',
		width: '245px',
		align: 'center',
		scopedSlots: { customRender: 'fourG' },
	},
];

import { TreeSelect } from 'ant-design-vue';
// import { defineComponent, ref } from 'vue';

const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const SHOW_CHILD = TreeSelect.SHOW_CHILD;
export default {
	props: {
		codeLength: {
			default: 12,
			type: Number,
		},
	},
	data() {
		return {
			activeDate: '2023-01-13',
			showBirthday: true,
			nowOper_birth_index: Number,
			datesRange: [],
			routeIsSearch: this.$route.path == '/admin/radarMonitorDeploy' ? 1 : 0, //当前是否为搜索路由 1为是
			whatType: '', //1床 2卫生间
			keyWord: this.$route.query.keyWord || '', //搜索关键词
			columns,
			tableData: [], // 表格数据
			total: 0,
			pageNum: 1,
			pageSize: 20,
			bedVal: undefined,
			roleList: [
				{ title: '管理员', val: '1' },
				{ title: '院长', val: '2' },
			],
			selectDataList: [], // 床位下拉框数据
			addRadarPopup: false, // 添加雷达弹窗状态
			loading: false,
			codeList: [],
			code: '',
			delTimePopup: false, // 删除弹窗
			timer: null,
			radarName: '', // 雷达名称
			deleteRadarTip: '',
			typeData: [
				{ id: 1, name: '床' },
				{ id: 2, name: '卫生间' },
			],
			typeVal: 1,
			radarSnList: [{ snCode: '' }],
			addRadarFeedback: false, // 添加监测仪后反馈弹窗
			v3_radarData: '', // 添加监测仪后反馈数据
			nowScope: '',

			emptyInfoPopup: false, // 清空信息弹窗
			wcItem: '',
			delInfoPopup: false, // 删除用户，清空用户信息弹窗

			formVisible: false,
			activeSnCode: '',
			activeBed: '',
			activeForm: {},
			bedName: '',
			snCode: '',
			bindMobilePhone: '',
			inputForm: {
				name: '',
				gender: '',
				age: '',
				nurGrade: '',
				actAbility: '',
				mobilePhone: '',
				breath: ['', ''],
				heart: ['', ''],
				insomnia: '',
				snore: '',
				nightOut: '',
				resDisease: [],
				comments: '',
				recordStatus: '',
				bindMobilePhone: '',
				bicVo: {
					name: '243243',
				},
			},
			inputForm_index: '', //操作inputForm中的第几个
			inputFormEmpty: {
				name: '',
				gender: '',
				age: '',
				nurGrade: '',
				actAbility: '',
				breath: ['', ''],
				heart: ['', ''],
				insomnia: '',
				snore: '',
				nightOut: '',
				resDisease: [],
				comments: '',
			},
			secondBreath: false,
			secondHeart: false,
			inputFormSelectRaw: {},
			inputFormSelect: {},
			isEditing: false,
			formTitle: '',
			activeBedId: null,
			isInput: true,
			copySDB: [''], //isInput为true时候 用这个代替inputForm.sleepDisorderedBreathing(不知道为啥用inputForm.sleepDisorderedBreathing有bug)
			ioc: true,
			checkDataList: [],
			exFilePath: null,
			localFileName: null,
			exportShow: false,
			exLoading: false,
			exList: [],
			unbound: false,
			activeBedScope: null,
			exSuccess: false,
			exWarning: false,

			// 4G套餐情况相关
			cardMerchant: null,     //卡商
			iccId: null,            //卡号
			qrCode_baseUrl: null,   //二维码地址（base64形式）

			// 设置相关
			set_formVisible: false, //设置弹窗是否显示
			set_formTitle: '',
			set_formType: 1, //设置的是单个还是批量 1单个 2批量
			set_snCode: '', //当前设置的sn
			set_snCodeList: '', //当前设置的snList
			fallExistLamp: true, //存在灯
			fallLamp: true, //跌倒灯
			fallNetLamp: true, //设备网络灯
			fallMonh: '', //监测高度
			fallMonhTip: false, //监测高度提示
			fallAlat: '', //报警时间
			fallAlatTip: false, //报警时间提示

			// 树形结构部分
			treeDatas: [],
			treeStrategy: SHOW_PARENT,
			valueSn: [],
			valueBakSn: [],

			// 设置批量倒计时弹窗部分
			set_formVisible_ing: false, //设置弹框中点确定后显示设置中弹窗
			set_pl_timer: '', // 批量弹窗定时器
			countDown: 60, //倒计时60s
			requestId: '', //批量设置接口返回的ID

			// 结果弹窗部分
			set_formVisible_plSucces: false, //设置批量成功
			plResultData: {}, // 批量结果数据

			// 批量导入床位信息部分
			fileList: [], //必须用这个字段，官网需要
			upState: 0, //上传文件状态 0选择文件 1上传中 2重新上传

			// 检测数据 || 导入数据部分
			importExcelData: null, // WEB管理员上传批量上传用户信息Excel

			excelState: -1, //检测中0 检测完成1
			importExcelCode: -1, //检测接口返回的code0 模板错误 code1数据错误，数据正确
			isImportFalseMsg: null, //模板错误返回字段

			// 关联卫生间部分
			radarId: '', //当前操作的监测仪id
			relateWC: false, //关联卫生间弹窗是否显示
			relateWcType: '', //1查看关联 2关联卫生间
			relateWC_Title: '',
			forceAssignment: [], //强制赋值当前选中位置（赋的值为最开始关联的值，若没有为空）

			// 关联卫生间树形结构部分
			relateWC_treeData: [],
			relateWC_treeData_value: [], //当前值,为进入查看时的值
			relateWC_treeData_value_Sel_Prev: [], //选中前的值
			relateWC_treeData_value_Sel_Next: [], //选中后的值

			// 关联卫生间弹窗内确认删除弹窗
			del_relateWC_Tan: false,

			// 关联手表部分
			relateWatchVisible: false,
			relateWatchType: '', //1查看关联 2关联手表
			relateWatchTitle: '',
			relateWatchValue: '',
			relateWatchLoading: false,
			relateWatchError: '',
			relateWatchCurrentRow: null,

			// 一键清空
			isShowOneKeyClearAlert: false,
			currentOneKeyClearModel: null,

			isShowTipAlertWqsn: false,

			currentPreviewItem: null, //当前预览的item
		};
	},
	mounted() {
		// 定义一个数组用于循环
		this.codeList = new Array(this.codeLength).fill('');

		this.getTableData();
		this.getSelectData();
		this.getBedInfo();
	},
	watch: {
		// 截取字符长度
		code() {
			this.code = this.code.substring(0, this.codeLength);
		},
		fallMonh(val) {
			this.fallMonhTip = false;
		},
		fallAlat(val) {
			this.fallAlatTip = false;
		},
		relateWatchValue(val) {
			const nextValue = (val || '')
				.replace(/[\u4E00-\u9FA5]/g, '')
				.replace(/\s+/g, '');
			if (nextValue !== val) {
				this.relateWatchValue = nextValue;
				return;
			}
			if (this.relateWatchError) {
				this.relateWatchError = '';
			}
		},
		// 倒计时弹框显示后开始倒计时
		set_formVisible_ing(val) {
			console.log(val);
			if (val == true) {
				this.set_pl_timer = setInterval(() => {
					this.countDown = this.countDown - 1;
				}, 1000);
			} else {
				clearInterval(this.set_pl_timer);
			}
		},
		// 倒计时监听
		countDown(val) {
			console.log(3837);
			if (
				val == 59 ||
				val == 49 ||
				val == 39 ||
				val == 29 ||
				val == 19 ||
				val == 9 ||
				val == 1
			) {
				this.selecBatchtFallDownAttr(); //查询批量设置设备信息
			}
			if (val == 0) {
				clearInterval(this.set_pl_timer);
				this.set_formVisible_ing = false; //隐藏弹窗
				this.set_formVisible_plSucces = true; //显示结果弹窗
			}
		},
	},
	methods: {
		// 行为状态值改变
		actionStateSelectChange(value) {
		},
		setSpecialStateAlertSureClick() {
			this.isShowTipAlertWqsn = false;
			this.onSubmit();
		},
		setSpecialStateAlertCancelClick() {
			this.isShowTipAlertWqsn = false;
		},
		onSearch(e) {
			console.log(e);
			// this.$router.push('./searchPage?keyWord='+e)
			this.$router.push('./radarMonitorDeploy?keyWord=' + e);
		},
		// (type1删除0添加  wcIndex代表inputForm的角标  )
		deleteBreath(type, wcIndex) {
			if (type == 1) {
				this.inputForm[wcIndex].breath.length--;
			} else if (type == 0) {
				this.inputForm[wcIndex].breath[1] = '';
			}
			this.$forceUpdate();
		},
		deleteHeart(type, wcIndex) {
			if (type == 1) {
				this.inputForm[wcIndex].heart.length--;
			} else if (type == 0) {
				this.inputForm[wcIndex].heart[1] = '';
			}
			this.$forceUpdate();
		},
		// 录入查看床位确定按钮
		onSubmitNew() {
			let icWqsn = false;
			if (this.inputForm && this.inputForm.length > 0) {
				for (let i = 0; i < this.inputForm.length; i++) {
					let item = this.inputForm[i];
					if (item.livingState == 4) {
						icWqsn = true;
					}
				}
			}
			// 1.判断是否设置为完全失能
			if (icWqsn) {
				this.isShowTipAlertWqsn = true;
			} else {
				this.onSubmit();
			}
		},
		onSubmit() {
			// 名字处理提示,处理完后才可处理数据 所以和下面for循环分开写
			for (let i = 0; i < this.inputForm.length; i++) {
				// if (!this.inputForm[i].name && !this.inputForm[i].bicVo.name) { // 2026-03-04依据需求修改，注释该逻辑，C端绑定是必须填写姓名，纯B绑定可以随便填写
					// 新增：如果是纯B端用户，姓名可以填写也可以不填写（需求确定时间：2026-03-04）
					if (this.currentPreviewItem && this.currentPreviewItem.hasConsumer && (!this.inputForm[i].name || this.inputForm[i].name == '')) {
						this.$message.warning('请输入姓名后再点击确定');
						return;
					}
				// }
			}
			if (this.isInput) {
				//判断是录入进来true为是 否则为查看进来的
				for (let i = 0; i < this.inputForm.length; i++) {
					// 已知睡眠呼吸障碍疾病数据处理  数组长度大于1，去除第一个''选项 等于1不管 小于1加进去''
					let len = this.inputForm[i].sleepDisorderedBreathing.length;
					if (len > 1) {
						this.inputForm[i].sleepDisorderedBreathing.splice(0, 1);
					} else if (len < 1) {
						this.inputForm[i].sleepDisorderedBreathing.push('');
					}
				}
			}

			// 针对mobilePhone进行处理
			let tempInputForm = JSON.parse(JSON.stringify(this.inputForm))
			// if (!tempInputForm[0].mobilePhone) {
				tempInputForm[0].mobilePhone = tempInputForm[0].mobilePhoneChange
			// }
			delete tempInputForm[0].mobilePhoneChange;
			this.inputForm = tempInputForm;
			
			// whatType 1床2卫生间
			// isInput   //判断是录入进来true为是 否则为查看进来的
			if (this.whatType == 1) {
				//床
				let requireUrl = '';
				if (this.isInput) {
					requireUrl = '/api/bedInformation/add'; //添加
				} else {
					requireUrl = '/api/bedInformation/update'; //修改
				}
				this.$post(
					requireUrl,
					this.inputForm[0],
					(res) => {
						if (res.code == 0) {
							this.formVisible = false;
							if (this.isInput) {
								this.$message.success('添加成功');
							} else {
								this.$message.success('修改成功');
							}
							this.getTableData();
						} else {
							if (this.isEditing == 1) {
								this.$message.error(res.msg || '添加失败');
							} else {
								this.$message.success('添加成功');
							}
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					}
				);
			} else if (this.whatType == 2) {
				//卫生间
				this.$post(
					'/api/v3/radar/submitToilet',
					{
						bedInformationV3DtoList: this.inputForm,
						snCode: this.snCode,
					},
					(res) => {
						if (res.code == 0) {
							this.formVisible = false;
							if (this.isInput) {
								// this.$message.success("操作成功");
								this.$message.success(res.msg);
							} else {
								// this.$message.success("修改成功");
								this.$message.success(res.msg);
							}
							this.getTableData();
						} else {
							if (this.isEditing == 1) {
								this.$message.error('添加失败');
							} else {
								this.$message.success('添加成功');
							}
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					}
				);
			}
		},
		cli_toiAddUser() {
			console.log(this.inputForm);
			let data = {
				actionAbility: '',
				ageGroup: '',
				bedName: '',
				bicVo: {},
				bindMobilePhone: '',
				birthday: '',
				breath: [''],
				cognitiveState: '',
				fallHistory: '',
				fallId: '',
				gait: '',
				heart: [''],
				id: 0,
				idCard: '',
				infusion: '',
				insomnia: '',
				medicalDiagnosis: '',
				mobilePhone: '',
				name: '',
				nightFrequency: '',
				nursingLevel: '',
				remarks: '',
				sex: '',
				sleepDisorderedBreathing: [''],
				snCode: '',
				snore: '',
				recordStatus: 0,
			};
			this.inputForm.push(data);
		},
		onEdit() {
			this.isEditing = true;
			this.isInput = false; //判断是录入进来true为是 否则为查看进来的
			//whatType 1床 2卫生间
			if (this.whatType == 1) {
				this.getRealBedInfoBySnCode();
				console.log(this.inputForm);
			} else if (this.whatType == 2) {
				this.getToilet(); //查看卫生间关联信息
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		inputInfo(scope) {
			console.log(scope);
			this.currentPreviewItem = null;
			this.initInputForm(); //初始化inputForm
			this.formVisible = true;
			this.isEditing = true; //是否是编辑状态
			this.whatType = scope.type; //1床 2卫生间
			this.isInput = true; //判断是录入进来true为是 否则为查看进来的
			this.activeSnCode = scope.snCode.split('（')[0];
			if (
				scope.buildingName &&
				scope.floorName &&
				scope.roomName &&
				scope.bedName
			) {
				this.activeBed =
					scope.buildingName +
					'/' +
					scope.floorName +
					'/' +
					scope.roomName +
					'/' +
					scope.bedName;
			} else {
				this.activeBed = '';
			}
			if (this.whatType == 1) {
				this.formTitle = '录入床位信息';
				this.inputForm[0].snCode = this.activeSnCode;
				this.inputForm[0].bedName = this.activeBed;
			} else if (this.whatType == 2) {
				this.formTitle = '录入卫生间信息';
				this.getToilet_Id = scope.id;
				this.getToilet(); //获取卫生间信息
				// this.toi_now_snCode = this.activeSnCode;      //卫生间当前sncode
				// this.toi_now_bedName = this.activeBed;        //卫生间当前床位名称
			}
			console.log(this.inputForm);
		},
		checkInfo(scope) {
			// console.log(scope)
			// console.log(this.tableData[0])
			this.currentPreviewItem = null;
			this.whatType = scope.type; //1床 2卫生间
			this.isInput = false; //判断是录入进来true为是 否则为查看进来的
			this.formVisible = true;
			this.isEditing = false;
			if (scope.type == 1) {
				this.currentPreviewItem = JSON.parse(JSON.stringify(scope));
				//床
				this.formTitle = '查看床位信息';
				this.activeSnCode = scope.snCode.split('（')[0];
				this.getRealBedInfoBySnCode(); //查看床位信息
			} else if (scope.type == 2) {
				//卫生间
				this.formTitle = '查看卫生间信息';
				this.getToilet_Id = scope.id;
				this.getToilet(); //获取卫生间信息
			}
		},
		// 获取卫生间信息
		getToilet() {
			this.$get(
				'/api/v3/radar/getToilet',
				{
					id: this.getToilet_Id,
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.snCode = res.data.snCode;
							this.bedName = res.data.bedName;
							this.bindMobilePhone = res.data.bindMobilePhone;
							this.inputForm = res.data.bedInformationList;
							console.log('inputForm=============' + this.inputForm);
						} else {
							this.$message.error(res.msg);
						}
					} else {
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		// 点击清空信息
		deleteInfo(scope) {
			this.whatType = scope.type; //1床 2卫生间
			this.nowScope = scope;
			if (this.whatType == 1) {
				this.emptyInfoPopup = true;
				this.deleteRadarTip =
					'即将清空监测仪"' + scope.snCode + '"，您确定要清空吗？';
			} else if (this.whatType == 2) {
				this.emptyInfoPopup = true;
				this.deleteRadarTip =
					'即将清空监测仪"所有录入信息' + scope.snCode + '"，您确定要清空吗？';
			}
		},
		// 点击删除用户
		// inputForm_index    操作inputForm中的第几个
		// wcItem   当前操作的数据
		// recordStatus    记录状态: 0-前端添加 1-后端返回(关联) 2-后端返回(添加)
		delInfo(inputForm_index, wcItem) {
			if (wcItem.recordStatus == 1 || wcItem.recordStatus == 2) {
				//记录状态: 0-前端添加 1-后端返回(关联) 2-后端返回(添加) 显示二次确认弹窗
				this.inputForm_index = inputForm_index; //操作inputForm中的第几个
				this.wcItem = wcItem;
				this.deleteRadarTip = '确定要删除这个用户信息吗？';
				this.delInfoPopup = true;
			} else {
				this.inputForm.splice(this.inputForm_index, 1);
			}
		},
		// 点击清空或删除
		deleteToilet() {
			let param = {
				fallId: this.wcItem.fallId, //跌倒设备ID
				id: this.wcItem.id, //床位信息ID
				radarId: this.wcItem.radarId, //监测仪ID
				recordStatus: this.wcItem.recordStatus, //记录状态: 0-前端添加 1-后端返回(关联) 2-后端返回(添加)
			};
			this.$delete(
				'/api/v3/radar/deleteToilet',
				param,
				(res) => {
					if (res.code == 0) {
						this.inputForm.splice(this.inputForm_index, 1);
						this.delInfoPopup = false;
						this.$message.success(res.msg);
						this.getTableData();
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 设置初始化
		setInfoInt() {
			this.fallMonh = 2.5;
			this.fallAlat = 120;
			this.fallUseh = 2;
			this.countDown = 60;
			// this.countDown = 3;
			this.plResultData = {};
		},
		// 点击设置
		setInfo(scope) {
			console.log(scope);
			this.set_formVisible = true;
			if (scope == '批量') {
				this.set_formType = 2;
				this.set_formTitle = '批量设置卫生间设备';
				this.setInfoInt();
				this.getBedTreeData();
			} else {
				this.set_formType = 1;
				this.set_formTitle = '设置' + scope.snCode;
				this.set_snCode = scope.snCode.split('（')[0];
				this.selectFallDownAttr(); //单个查询跌倒设备属性
			}
		},
		// 设置弹窗内点击确定
		set_onSubmit() {
			// console.log(this.fallExistLamp,this.fallLamp,this.fallNetLamp)
			let errData = 0;
			if (this.fallMonh < 2.1 || this.fallMonh > 3) {
				// 监测高度2.1-3
				this.fallMonhTip = true;
				errData += 1;
			}
			if (this.fallAlat < 10 || this.fallAlat > 240) {
				// 报警时间10-240
				this.fallAlatTip = true;
				errData += 1;
			}
			if (this.set_formType == 1) {
				//单个
				if (errData == 0) {
					console.log('点了确定');
					this.setFallDownAttr(); // 单个设置跌倒设备属性
				}
			} else {
				//批量
				// this.$message.success("设置批量");
				let _this = this;
				let snArr = [];
				for (let i = 0; i < this.valueSn.length; i++) {
					let target = this.valueSn[i].toString();
					let data = this.treeDatas;
					snArr = [...snArr, ...this.getSn(target, data)];
				}
				console.log(snArr);
				this.set_snCodeList = snArr;
				this.$confirm({
					title: '即将批量修改当前机构卫生间设备的开关和配置，确定要设置吗？',
					onOk() {
						// 接口成功回调
						_this.set_formVisible = false;
						_this.batchSetFallDownAttr(); //批量设置跌倒设备属性
					},
				});
			}
		},
		// 双递归拿到snArr
		getSn(target, data) {
			console.log(target);
			console.log(data);
			const res = [];
			function deep(arr) {
				console.log(arr);
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].snCode && !arr[i].disabled) {
						res.push(arr[i].snCode);
					}
					if (arr[i].children) {
						deep(arr[i].children);
					}
				}
			}
			function tree(target, arr) {
				console.log(target, arr);
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].id === target) {
						console.log('=======');
						if (arr[i].snCode) {
							res.push(arr[i].snCode);
						} else {
							return deep(arr[i].children);
						}
					} else if (arr[i].children) {
						console.log('!!!!!!');
						tree(target, arr[i].children);
					}
				}
			}
			tree(target, data);
			return res;
		},
		// 批量设置跌倒设备属性
		batchSetFallDownAttr() {
			this.$post(
				'/api/radar/batchSetFallDownAttr',
				{
					snList: this.set_snCodeList,
					fallExistLamp: this.fallExistLamp ? 1 : 0,
					fallLamp: this.fallLamp ? 1 : 0,
					fallNetLamp: this.fallNetLamp ? 1 : 0,
					fallMonh: this.fallMonh,
					fallAlat: this.fallAlat,
				},
				(res) => {
					if (res.code == 0) {
						// this.$message.success("设置成功");
						this.requestId = res.data.requestId;
						this.set_formVisible_ing = true;
					} else {
						this.$message.error('设置失败，请稍后重试');
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
			console.log('走接口');
		},
		// 查询批量设置设备信息
		selecBatchtFallDownAttr() {
			this.$get(
				'/api/radar/selecBatchtFallDownAttr',
				{ requestId: this.requestId },
				(res) => {
					if (res.code == 0) {
						console.log('成功');
						this.plResultData = res.data;
						//成功
						if (this.plResultData.successCount == this.plResultData.total) {
							clearInterval(this.set_pl_timer);
							this.set_formVisible_ing = false;
							this.set_formVisible_plSucces = true;
						} else {
							//失败

							this.set_snCodeList = [];
							for (let i = 0; i < this.plResultData.failList.length; i++) {
								this.set_snCodeList.push(this.plResultData.failList[i].id);
							}
							// this.set_snCodeList.push('f49','f50');
							this.valueSn = this.set_snCodeList;
							console.log(this.valueSn);
						}
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		// 点击我知道了
		set_onSubmit_succ() {
			this.set_formVisible_plSucces = false;
		},
		// 点击继续设置
		set_onSubmit_goSet() {
			this.set_formVisible_plSucces = false;
			setTimeout(() => {
				this.setInfo('批量');
			}, 200);
		},

		// 单个查询跌倒设备属性
		selectFallDownAttr() {
			this.$get(
				'/api/radar/selectFallDownAttr',
				{ sn: this.set_snCode },
				(res) => {
					if (res.code == 0) {
						console.log(res.data.fallExistLamp);
						this.fallExistLamp = res.data.fallExistLamp == 1 ? true : false;
						this.fallLamp = res.data.fallLamp == 1 ? true : false;
						this.fallNetLamp = res.data.fallNetLamp == 1 ? true : false;

						this.fallMonh = res.data.fallMonh;
						this.fallAlat = res.data.fallAlat;
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 单个设置跌倒设备属性
		setFallDownAttr() {
			console.log('进入');
			this.$post(
				'/api/radar/setFallDownAttr',
				{
					sn: this.set_snCode,
					fallExistLamp: this.fallExistLamp ? 1 : 0,
					fallLamp: this.fallLamp ? 1 : 0,
					fallNetLamp: this.fallNetLamp ? 1 : 0,
					fallMonh: this.fallMonh,
					fallAlat: this.fallAlat,
				},
				(res) => {
					if (res.code == 0) {
						this.$message.success('设置成功');
						this.set_formVisible = false;
					} else {
						this.$message.error('设置失败，请稍后重试');
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 点击下载问题数据
		downProblemData() {
			let tenantId = this.importExcelData.tenantId;
			window.open(
				this.$store.state.baseUrl +
				'/api/v3/radar/downloadProblemData?filePath=' +
				this.exFilePath +
				'&tenantId=' +
				tenantId
			);
		},
		// 树形结构部分start________________________________
		// 获取床位树形数据
		getBedTreeData() {
			var that = this;
			this.$get(
				// "/api/dean/bedTree",
				// { userId: 551 },
				'/api/radar/getFallDownTree',
				{},
				(res) => {
					if (res.code == 0) {
						console.log(res);
						that.treeDatas = res.data.children;
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		onSelect(value, node, extra) {
			console.log(this.valueSn);
			// console.log(value,node,extra)
		},
		// 树形结构部分end________________________________
		// 点击批量导入床位信息
		clickBatchBedInfo() {
			this.exportShow = true;
			this.exLoading = false;

			// 数据初始化
			this.upState = 0;
			this.importExcelData = null;
			this.excelState = -1;
			this.importExcelCode = -1;
			this.isImportFalseMsg = null;
		},

		formIsEmpty() {
			for (let i = 0; i < this.inputForm.length; i++) {
				if (!this.inputForm[i].name) {
					return false;
				}
			}
		},

		handleUpload(info) {
			if (info.file.status !== 'uploading') {
				// 如果不是excel文件
				if (
					info.file.type !=
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
					info.file.type != 'application/vnd.ms-excel'
				) {
					this.$message.error('文件类型错误，请上传excel类型文件');
					return;
				}
				// 如果不是excel文件end
				this.localFileName = info.file.name; //本地文件名字
				this.upState = 1; //上传中
				this.exFilePath = info.file.response.data.filePath;
				console.log('hello', info.file.response.data.filePath);
			}
			if (info.file.status === 'done') {
				// this.$message.success(`${info.file.name} 上传成功`);
				this.upState = 2; //上传成功，重新上传
				this.importExcel(false); //WEB管理员上传批量上传用户信息Excel
			} else if (info.file.status === 'error') {
				this.$message.error(`${info.file.name} 上传失败.`);
				this.upState = 0; //上传失败，选择文件
			}
		},
		// WEB管理员上传批量上传用户信息Excel(type走检测false,走上传true)
		importExcel(type) {
			if (type) {
				this.exLoading = true;
			} else {
				this.excelState = 0; //检测中0  检测完成1
			}
			setTimeout((e) => {
				this.$post(
					'/api/v3/radar/addBatch',
					{
						filePath: this.exFilePath,
						isImport: type, // 检测false  上传true
					},
					(res) => {
						this.importExcelCode = res.code; //code0 模板错误 code1数据错误，数据正确
						this.excelState = 1; //检测中0  检测完成1
						if (res.code == 0) {
							// 走检测false
							if (!type) {
								this.importExcelData = res.data;
							} else {
								//走导入true
								this.exportShow = false;
								this.$message.success(res.msg);
							}
							this.exLoading = false;
						} else {
							if (!type) {
								//走检测
								this.isImportFalseMsg = res.msg; //模板错误返回字段
							} else {
								//走导入
								this.$message.error(res.msg);
								this.exLoading = false;
							}
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
						this.exLoading = false;
					}
				);
			}, 500);
		},
		// 获取table数据
		getTableData() {
			let param = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				snCode: this.keyWord, //关键字
			};
			this.$get(
				'/api/radar/showPage',
				param,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							if (!res.data.radarShowVOIPage.records && this.pageSize !== 1) {
								this.pageNum = this.pageNum - 1;
								this.getTableData();
								return;
							}
							var records = res.data.radarShowVOIPage.records;
							for (var i = 0; i < records.length; i++) {
								if (records[i].existBedMsg) {
									this.checkDataList.push(records[i].snCode.split('（')[0]);
								}
							}
							this.columns[0].title = `监测仪SN码(共${res.data.snCodeNum}个，${res.data.monitorBedNum}个床位设备，${res.data.monitorToiletNum}个卫生间设备)`;
							// this.columns[1].title = `监测床位(共监测${res.data.monitorBedNum}个床位&${res.data.monitorToiletNum}个卫生间)`
							this.total = res.data.radarShowVOIPage.total;
							if (res.data.radarShowVOIPage.records) {
								for (let i = 0; i < res.data.radarShowVOIPage.records.length; i++) {
									res.data.radarShowVOIPage.records[i].isRefreshShow = false;   //初始默认刷新按钮都为false
									if (res.data.radarShowVOIPage.records[i].bedId) {
										res.data.radarShowVOIPage.records[i].value = [
											'b' +
											res.data.radarShowVOIPage.records[i].buildingId +
											'',
											'f' + res.data.radarShowVOIPage.records[i].floorId + '',
											'r' + res.data.radarShowVOIPage.records[i].roomId + '',
											res.data.radarShowVOIPage.records[i].bedId + '',
										];
									} else {
										res.data.radarShowVOIPage.records[i].value = [];
									}
								}
								this.tableData = res.data.radarShowVOIPage.records;
							} else {
								this.tableData = [];
							}
							console.log(this.tableData);
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		checkShowList(scope) {
			if (this.checkDataList.indexOf(scope.snCode.split('（')[0]) == -1)
				return false;
			else return true;
		},
		// 分页
		pageChange(e) {
			console.log(e);
			this.pageNum = e;
			this.getTableData();
		},
		// 下拉框处理逻辑
		getInputFormSelect() {
			//性别
			var g = [];
			for (var i = 0; i < this.inputFormSelectRaw.sex.length; i++) {
				for (var key in this.inputFormSelectRaw.sex[i]) {
					g.push({
						value: Number(key),
						label: this.inputFormSelectRaw.sex[i][key],
					});
				}
			}
			this.inputFormSelect['gender'] = g;
			//年龄段
			var ag = [];
			for (var i = 0; i < this.inputFormSelectRaw.age_group.length; i++) {
				for (var key in this.inputFormSelectRaw.age_group[i]) {
					ag.push({
						value: Number(key),
						label: this.inputFormSelectRaw.age_group[i][key],
					});
				}
			}
			this.inputFormSelect['age'] = ag;
			//护理等级
			var ng = [];
			for (var i = 0; i < this.inputFormSelectRaw.nursing_level.length; i++) {
				for (var key in this.inputFormSelectRaw.nursing_level[i]) {
					ng.push({
						value: Number(key),
						label: this.inputFormSelectRaw.nursing_level[i][key],
					});
				}
			}
			this.inputFormSelect['nurGrade'] = ng;
			//行动能力
			var aa = [];
			for (var i = 0; i < this.inputFormSelectRaw.action_ability.length; i++) {
				for (var key in this.inputFormSelectRaw.action_ability[i]) {
					aa.push({
						value: Number(key),
						label: this.inputFormSelectRaw.action_ability[i][key],
					});
				}
			}
			this.inputFormSelect['actAbility'] = aa;
			//行为状态
			var xwzt = [];
			for (var i = 0; i < this.inputFormSelectRaw.living_state.length; i++) {
				for (var key in this.inputFormSelectRaw.living_state[i]) {
					xwzt.push({
						value: Number(key),
						label: this.inputFormSelectRaw.living_state[i][key],
					});
				}
			}
			this.inputFormSelect['living_state'] = xwzt;
			//呼吸
			var b = [];
			for (var i = 0; i < this.inputFormSelectRaw.breath.length; i++) {
				for (var key in this.inputFormSelectRaw.breath[i]) {
					b.push({
						value: key,
						label: this.inputFormSelectRaw.breath[i][key],
					});
				}
			}
			this.inputFormSelect['breath'] = b;
			//心脏
			var h = [];
			for (var i = 0; i < this.inputFormSelectRaw.heart.length; i++) {
				for (var key in this.inputFormSelectRaw.heart[i]) {
					h.push({ value: key, label: this.inputFormSelectRaw.heart[i][key] });
				}
			}
			this.inputFormSelect['heart'] = h;
			//是否失眠
			var ins = [];
			for (var i = 0; i < this.inputFormSelectRaw.insomnia.length; i++) {
				for (var key in this.inputFormSelectRaw.insomnia[i]) {
					ins.push({
						value: Number(key),
						label: this.inputFormSelectRaw.insomnia[i][key],
					});
				}
			}
			this.inputFormSelect['insomnia'] = ins;
			//是否打呼噜
			var s = [];
			for (var i = 0; i < this.inputFormSelectRaw.snore.length; i++) {
				for (var key in this.inputFormSelectRaw.snore[i]) {
					s.push({
						value: Number(key),
						label: this.inputFormSelectRaw.snore[i][key],
					});
				}
			}
			this.inputFormSelect['snore'] = s;
			//起夜频次
			var no = [];
			for (var i = 0; i < this.inputFormSelectRaw.night_frequency.length; i++) {
				for (var key in this.inputFormSelectRaw.night_frequency[i]) {
					no.push({
						value: Number(key),
						label: this.inputFormSelectRaw.night_frequency[i][key],
					});
				}
			}
			this.inputFormSelect['night_frequency'] = no;
			//已知睡眠呼吸障碍疾病
			var cnm = [];
			for (
				var i = 0;
				i < this.inputFormSelectRaw.sleep_disordered_breathing.length;
				i++
			) {
				for (var key in this.inputFormSelectRaw.sleep_disordered_breathing[i]) {
					cnm.push({
						value: Number(key),
						label: this.inputFormSelectRaw.sleep_disordered_breathing[i][key],
					});
				}
			}
			this.inputFormSelect['sleepDisorderedBreathing'] = cnm;
			// 跌倒史
			let fall_history = [];
			for (let i = 0; i < this.inputFormSelectRaw.fall_history.length; i++) {
				for (let key in this.inputFormSelectRaw.fall_history[i]) {
					fall_history.push({
						value: Number(key),
						label: this.inputFormSelectRaw.fall_history[i][key],
					});
				}
			}
			this.inputFormSelect['fallHistory'] = fall_history;
			// 有超过1个医学诊断
			let medical_diagnosis = [];
			for (
				let i = 0;
				i < this.inputFormSelectRaw.medical_diagnosis.length;
				i++
			) {
				for (let key in this.inputFormSelectRaw.medical_diagnosis[i]) {
					medical_diagnosis.push({
						value: Number(key),
						label: this.inputFormSelectRaw.medical_diagnosis[i][key],
					});
				}
			}
			this.inputFormSelect['medicalDiagnosis'] = medical_diagnosis;
			// 静脉输液/置管/使用特殊药物
			let infusion = [];
			for (let i = 0; i < this.inputFormSelectRaw.infusion.length; i++) {
				for (let key in this.inputFormSelectRaw.infusion[i]) {
					infusion.push({
						value: Number(key),
						label: this.inputFormSelectRaw.infusion[i][key],
					});
				}
			}
			this.inputFormSelect['infusion'] = infusion;
			// 步态
			let gait = [];
			for (let i = 0; i < this.inputFormSelectRaw.gait.length; i++) {
				for (let key in this.inputFormSelectRaw.gait[i]) {
					gait.push({
						value: Number(key),
						label: this.inputFormSelectRaw.gait[i][key],
					});
				}
			}
			this.inputFormSelect['gait'] = gait;
			// 认知状态
			let cognitive_state = [];
			for (let i = 0; i < this.inputFormSelectRaw.cognitive_state.length; i++) {
				for (let key in this.inputFormSelectRaw.cognitive_state[i]) {
					cognitive_state.push({
						value: Number(key),
						label: this.inputFormSelectRaw.cognitive_state[i][key],
					});
				}
			}
			this.inputFormSelect['cognitiveState'] = cognitive_state;
			console.log('inputFormSelect====', this.inputFormSelect);
		},
		getBedInfo() {
			this.$get(
				'/api/bedInformation/getType',
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.inputFormSelectRaw = res.data;
							this.getInputFormSelect();
						} else {
							this.$message.error(res.msg);
						}
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		initInputForm() {
			this.inputForm = [
				{
					id: null,
					snCode: '',
					name: '',
					sex: null,
					ageGroup: null,
					actionAbility: null,
					nursingLevel: null,
					breath: [''],
					heart: [''],
					insomnia: null,
					snore: null,
					nightFrequency: null,
					sleepDisorderedBreathing: [''],
					createTime: [],
					modifyTime: null,
					tenantId: null,
					fallHistory: null,
					medicalDiagnosis: null,
					infusion: null,
					gait: null,
					cognitiveState: null,
					remarks: '',
					bedName: '',
					living_state: null,
					bicVo: {},
				},
			];
		},
		// 查看床位回显数据
		getRealBedInfoBySnCode() {
			this.$get(
				'/api/bedInformation/getByBedSnCode',
				{
					snCode: this.activeSnCode,
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							let tempData = res.data;
							let needData = [];
							if (tempData && tempData.length > 0) {
								for (let i = 0; i < tempData.length; i++) {
									let tempItem = tempData[i];
									let needItem = JSON.parse(JSON.stringify(tempItem));
									if ((!needItem.name || needItem.name == '') && needItem.bicVo.name && needItem.bicVo.name != '') {
										needItem.name = needItem.bicVo.name;
									}
									if (!needItem.sex && needItem.bicVo.sex) {
										needItem.sex = needItem.bicVo.sex;
									}
									if (!needItem.idCard && needItem.bicVo.idCard) {
										needItem.idCard = needItem.bicVo.idCard;
									}
									if (!needItem.birthday && needItem.bicVo.birthday) {
										needItem.birthday = needItem.bicVo.birthday;
									}
									if (!needItem.actionAbility && needItem.bicVo.actionAbility) {
										needItem.actionAbility = needItem.bicVo.actionAbility;
									}
									if (!needItem.breath && needItem.bicVo.breath) {
										needItem.breath = needItem.bicVo.breath;
									}
									if (!needItem.heart && needItem.bicVo.heart) {
										needItem.heart = needItem.bicVo.heart;
									}
									if (!needItem.insomnia && needItem.bicVo.insomnia) {
										needItem.insomnia = needItem.bicVo.insomnia;
									}
									if (!needItem.snore && needItem.bicVo.snore) {
										needItem.snore = needItem.bicVo.snore;
									}
									if (!needItem.sleepDisorderedBreathing && needItem.bicVo.sleepDisorderedBreathing) {
										needItem.sleepDisorderedBreathing = needItem.bicVo.sleepDisorderedBreathing;
									}
									if (!needItem.mobilePhone && needItem.bicVo.mobilePhone) {
										needItem.mobilePhone = needItem.bicVo.mobilePhone;
									}
									if (needItem.mobilePhone) {
										if (needItem.mobilePhone.indexOf(',') >= 0) {
											needItem.mobilePhoneChange = ''
										} else {
											needItem.mobilePhoneChange = needItem.mobilePhone;
										}
									}
									if (!needItem.livingState && needItem.bicVo.livingState) {
										needItem.livingState = needItem.bicVo.livingState;
									}
									needData.push(needItem);
								}
							}
							this.inputForm = needData
							this.activeBedId = res.data.id;
							console.log('inputForm=============' + this.inputForm);
						} else {
							this.$message.error(res.msg);
						}
					} else {
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		// 点击清空信息_点击清空
		deleteInputInfo() {
			this.emptyInfoPopup = false;
			if (this.whatType == 1) {
				this.$get(
					'/api/bedInformation/deleteBySnCode',
					{
						snCode: this.activeSnCode,
					},
					(res) => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getTableData();
						} else {
							this.$message.success('删除失败');
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					}
				);
			} else if (this.whatType == 2) {
				this.$delete(
					'/api/v3/radar/clearToilet',
					{
						id: this.nowScope.id,
						snCode: this.nowScope.snCodeValue,
					},
					(res) => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getTableData();
						} else {
							this.$message.success('删除失败');
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					}
				);
			}
		},
		// 获取床tree数据
		getSelectData() {
			this.$get(
				'/api/bed/bedTree',
				{},
				(res) => {
					// console.log(res);
					if (res.code == 0) {
						if (res.data) {
							let arr = [];
							if (res.data.children) {
								for (let i = 0; i < res.data.children.length; i++) {
									arr.push({
										value: res.data.children[i].id,
										label: res.data.children[i].title,
										children: [],
									});
									if (res.data.children[i].children) {
										for (
											let n = 0;
											n < res.data.children[i].children.length;
											n++
										) {
											arr[i].children.push({
												value: res.data.children[i].children[n].id,
												label: res.data.children[i].children[n].title,
												children: [],
											});
											if (res.data.children[i].children[n].children) {
												for (
													let k = 0;
													k < res.data.children[i].children[n].children.length;
													k++
												) {
													arr[i].children[n].children.push({
														value:
															res.data.children[i].children[n].children[k].id,
														label:
															res.data.children[i].children[n].children[k]
																.title,
														children: [],
													});
													if (
														res.data.children[i].children[n].children[k]
															.children
													) {
														for (
															let j = 0;
															j <
															res.data.children[i].children[n].children[k]
																.children.length;
															j++
														) {
															arr[i].children[n].children[k].children.push({
																value:
																	res.data.children[i].children[n].children[k]
																		.children[j].id,
																label:
																	res.data.children[i].children[n].children[k]
																		.children[j].title,
																disabled:
																	res.data.children[i].children[n].children[k]
																		.children[j].disabled,
															});
														}
													}
												}
											}
										}
									}
								}
								// console.log(arr);
								this.selectDataList = arr;
							}
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 监听床位选择
		onChange(value, scope) {
			this.activeBedScope = scope;
			console.log(value, scope);
			if (value.length != 0) {
				var arr = value.filter(function (o) {
					return !isNaN(o);
				});
				let param = {
					bedId: arr[0],
					radarId: scope.id,
				};
				this.$post(
					'/api/radar/radarBed',
					param,
					(res) => {
						if (res.code == 0) {
							this.$message.success('绑定成功');
							this.getTableData();
							this.getSelectData();
						} else {
							this.$message.error(res.msg);
						}
					},
					(err) => {
						console.log(err);
						this.$message.error(err.msg);
					}
				);
			} else {
				console.log('解绑');

				this.unbound = true;
			}
		},
		unboundBed() {
			let param = {
				bedId: this.activeBedScope.bedId,
				radarId: this.activeBedScope.id,
			};
			console.log(param);
			this.$delete(
				'/api/radar/radarBed',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('解绑成功');
						// this.getTableData();
						// this.getSelectData();
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
			this.unbound = false;
			// location.reload();
		},
		unboundClear() {
			this.unboundBed();
			this.activeSnCode = this.activeBedScope.snCode.split('（')[0];
			var inf = JSON.stringify(this.inputFormEmpty);
			this.inputForm = JSON.parse(inf);
			this.deleteInputInfo();
			var index = this.checkDataList.indexOf(this.activeSnCode);
			if (index != -1) this.checkDataList.splice(index, 1);
			this.unbound = false;
			// location.reload();
		},
		unboundCancel() {
			this.getTableData();
			this.getSelectData();
			this.unbound = false;
			location.reload();
		},
		// +一个监测仪
		cliAddJcy() {
			let snCode = { snCode: '' };
			this.radarSnList.push(snCode);
		},
		// 点击添加监测仪
		addRadar() {
			this.radarSnList = [{ snCode: '' }];
			this.addRadarPopup = true;
		},
		// 添加确定
		addRadarOk() {
			let isCanGo = 0; //是否能添加 只要循环里有一个有数据即可添加
			for (let i = 0; i < this.radarSnList.length; i++) {
				if (this.radarSnList[i].snCode) {
					isCanGo = 1;
					this.radarSnList[i].inputListBorRed = false;
				} else {
					this.radarSnList[i].inputListBorRed = true;
				}
			}
			// this.loading = true;
			if (isCanGo != 1) {
				this.$forceUpdate();
				return;
			}
			let snCodeList = [];
			for (let i = 0; i < this.radarSnList.length; i++) {
				if (this.radarSnList[i].snCode) {
					snCodeList.push(this.radarSnList[i].snCode);
				}
			}
			let param = {
				snCodeList: snCodeList,
			};
			this.$post(
				'/api/v3/radar',
				param,
				(res) => {
					if (res.code == 0) {
						this.getTableData();
						this.v3_radarData = res.data;
						if (this.v3_radarData == null) {
							this.$message.success('添加成功');
						} else {
							this.addRadarFeedback = true; //添加监测仪后反馈弹窗
						}
						this.addRadarPopup = false; //添加雷达弹窗状态
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error(err.msg);
				}
			);
		},
		// 点击继续添加
		cli_goAddRadar() {
			console.log(this.v3_radarData);
			let bindList = this.v3_radarData.bindList;
			let tem_bindList = []; //临时反馈数据，不含C端用户
			let c_userArr = []; //C端用户数据数组
			for (let i = 0; i < bindList.length; i++) {
				if (bindList[i].tenant == 'C端用户') {
					c_userArr.push(bindList[i]);
				} else {
					tem_bindList.push(bindList[i]);
				}
			}
			this.v3_radarData.bindList = tem_bindList;
			console.log(this.v3_radarData);
			console.log(c_userArr);

			let c_userArrNew = c_userArr.map((item) => {
				return item.snCodeList;
			});
			console.log(c_userArrNew);

			if (c_userArrNew) {
				this.$post(
					'/api/v3/radar/addConsumer',
					{
						snCodeList: c_userArrNew[0],
					},
					(res) => {
						if (res.code == 0) {
							this.getTableData();
						} else {
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					}
				);
			}

			this.radarSnList = [];
			if (this.v3_radarData.noExist) {
				for (let i = 0; i < this.v3_radarData.noExist.snCodeList.length; i++) {
					let snCode = {
						snCode: this.v3_radarData.noExist.snCodeList[i],
						inputListBorRed: true,
					};
					this.radarSnList.push(snCode);
				}
			}
			if (this.v3_radarData.bindList) {
				for (let i = 0; i < this.v3_radarData.bindList.length; i++) {
					for (
						let j = 0;
						j < this.v3_radarData.bindList[i].snCodeList.length;
						j++
					) {
						let snCode = {
							snCode: this.v3_radarData.bindList[i].snCodeList[j],
							inputListBorRed: true,
						};
						this.radarSnList.push(snCode);
					}
				}
			}
			this.addRadarFeedback = false;
			this.addRadarPopup = true;
			console.log(this.radarSnList);
		},
		// 增减床位按钮
		addCutBed() {
			this.$router.push({
				path: '/admin/addCutBed',
			});
		},
		// 删除雷达按钮
		deleteRadar(scope) {
			console.log(scope);
			this.typeId = scope.id;
			this.radarName = scope.snCode;
			this.nowScope = scope;
			if (scope.hasConsumer) {
				//是否为c端机构的
				this.deleteRadarTip =
					'即将删除监测仪"' +
					scope.snCode +
					'"，设备已经在C端绑定，本次删除只会从本机构删除，您确定要删除吗？';
			} else {
				if (scope.isRadarOnline) {
					//存在录入信息
					this.deleteRadarTip =
						'即将删除监测仪"' +
						scope.snCode +
						'"，已经录入的设备信息也会被删除，您确定要删除吗？';
				} else {
					this.deleteRadarTip =
						'即将删除监测仪"' + scope.snCode + '"，您确定要删除吗？';
				}
			}

			this.delTimePopup = true;
			this.activeBedScope = scope;
		},
		// 确认删除雷达
		delTimeOk() {
			this.loading = true;
			console.log(this.nowScope);
			let param = {
				delBedInfo:
					this.nowScope.bedInfoStatus == 2 || this.nowScope.fallRelStatus == 3
						? true
						: false, //带录入信息true,否则false
				id: this.nowScope.id,
			};
			this.$delete(
				'/api/v3/radar/delete',
				param,
				(res) => {
					if (res.code == 0) {
						this.getTableData();
						this.delTimePopup = false;
						this.$message.success(res.msg);
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
					this.loading = false;
				}
			);
		},
		// table内点击关联卫生间(scope,type(1查看关联 2关联卫生间))
		clickReWC(scope, type) {
			this.radarId = scope.id; //当前操作的监测仪id
			this.getFallRelationTree(); //获取关联弹窗内树形结构
			this.relateWcType = type; //1查看关联 2关联卫生间
			if (type == 1) {
				//1查看关联
				this.relateWC_Title = '查看关联卫生间';
				this.getFallRelation(); //获取关联弹窗内树形结构
			} else if (type == 2) {
				//2关联卫生间
				this.relateWC_Title = '关联卫生间';
				this.relateWC_treeData_value = []; //当前值 为进入查看时的值
				this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value; //选中前的值
				this.relateWC_treeData_value_Sel_Next = this.relateWC_treeData_value; //选中后的值
			}
			this.relateWC = true; //弹窗显示

			// this.relateWC_treeData_value = []
			// this.relateWC_treeData_value = ['b23','f110','r265','493']      //当前值 为进入查看时的值
			// this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value;       //选中前的值
			// this.relateWC_treeData_value_Sel_Next = this.relateWC_treeData_value;       //选中后的值
		},
		// 获取关联弹窗内树形结构
		getFallRelationTree() {
			this.$get(
				'/api/radar/getFallRelationTree',
				{},
				(res) => {
					if (res.code == 0) {
						console.log('成功');
						this.relateWC_treeData = res.data.children;
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 获取查看关联
		getFallRelation() {
			this.$get(
				'/api/radar/getFallRelation',
				{
					radarId: this.radarId,
				},
				(res) => {
					if (res.code == 0) {
						console.log('成功');
						this.relateWC_treeData_value = res.data; //当前值 为进入查看时的值
						this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value; //选中前的值
						this.relateWC_treeData_value_Sel_Next = this.relateWC_treeData_value; //选中后的值
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 点击选择
		change_relateWC(value) {
			this.relateWC_treeData_value_Sel_Next = value; //赋值选中后的新值

			console.log(this.relateWC_treeData_value.length);
			console.log(value.length);

			console.log(this.relateWC_treeData_value);
			console.log(this.relateWC_treeData_value_Sel_Prev);
			console.log(this.relateWC_treeData_value_Sel_Next);

			if (this.relateWcType == 1) {
				// 查看关联
				if (value.length < 1) {
					// 当前选中后为空,执行的叉子操作
					// 选中前的值等于默认的值
					if (
						this.relateWC_treeData_value_Sel_Prev ==
						this.relateWC_treeData_value
					) {
						this.del_relateWC_Tan = true; //二次确认弹窗
					}
				} else {
					//如果不为空，为赋值操作，选中后的值赋值给选中前的值
					this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value_Sel_Next;
				}
			} else if (this.relateWcType == 2) {
				// 关联卫生间
				console.log('关联卫生间无需操作');
			}
		},
		// 关联床位卫生间
		gl_relateWC() {
			console.log(this.relateWC_treeData_value_Sel_Next);
			let len = this.relateWC_treeData_value_Sel_Next.length;
			let fallId = this.relateWC_treeData_value_Sel_Next[len - 1];

			this.$post(
				'/api/radar/radarFall',
				{
					fallId: fallId, //跌倒设备ID
					radarId: this.radarId, //监测仪id
				},
				(res) => {
					if (res.code == 0) {
						this.$message.success('床位卫生间关联成功');
						this.relateWC = false; //关闭弹窗
						this.getTableData(); //更新列表数据
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 取关床位卫生间
		radarFall() {
			console.log(this.relateWC_treeData_value);
			let len = this.relateWC_treeData_value.length;
			let fallId = this.relateWC_treeData_value[len - 1]; // 取消只用拿进入查看时的值即可
			this.$delete(
				'/api/radar/radarFall',
				{
					fallId: fallId, //跌倒设备ID
					radarId: this.radarId, //监测仪id
				},
				(res) => {
					if (res.code == 0) {
						this.$message.success('床位卫生间关联成功');
						this.del_relateWC_Tan = false; //关闭弹窗
						this.relateWC = false; //关闭弹窗
						this.getTableData(); //更新列表数据
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 查看关联部分中点击确定
		click_gl_Tan_Sure() {
			console.log(this.relateWC_treeData_value_Sel_Next);
			if (this.relateWC_treeData_value_Sel_Next.length < 1) {
				this.$message.error('设置失败，请选择需要关联的设备');
			} else {
				this.gl_relateWC(); //关联床位卫生间
			}
		},
		// 关联卫生间弹窗内删除弹窗 点击取消
		del_relateWC_Tan_Cancel() {
			this.del_relateWC_Tan = false; //隐藏当前弹窗
			this.relateWC_treeData_value_Sel_Next = this.relateWC_treeData_value; //强制赋值当前选中位置（赋的值为最开始关联的值，若没有为空）
		},
		// table内点击关联手表(scope,type(1查看关联 2关联手表))
		clickRelWatch(scope, type) {
			this.relateWatchCurrentRow = scope;
			this.relateWatchType = type;
			this.relateWatchError = '';
			if (type == 1) {
				this.relateWatchTitle = '查看关联手表';
				this.relateWatchValue = '';
				this.relateWatchVisible = true;
				this.getRelateWatch();
			} else if (type == 2) {
				this.relateWatchTitle = '关联手表';
				this.relateWatchValue = '';
				this.relateWatchVisible = true;
			}
		},
		getRelateWatch() {
			if (!this.relateWatchCurrentRow) {
				return;
			}
			this.relateWatchLoading = true;
			this.$get(
				'/api/radarWatch/getRadarWatch',
				{
					radarId: this.relateWatchCurrentRow.id,
				},
				(res) => {
					if (res.code == 0) {
						this.relateWatchValue =
							res.data && res.data.watchSnCode ? res.data.watchSnCode : '';
						this.relateWatchError = '';
					} else {
						this.relateWatchError = res.msg || '获取关联手表失败';
					}
					this.relateWatchLoading = false;
				},
				(err) => {
					console.log(err);
					this.relateWatchError = err.msg || '服务端发生异常';
					this.relateWatchLoading = false;
				}
			);
		},
		closeRelateWatchDialog() {
			this.relateWatchVisible = false;
			this.relateWatchType = '';
			this.relateWatchTitle = '';
			this.relateWatchValue = '';
			this.relateWatchLoading = false;
			this.relateWatchError = '';
			this.relateWatchCurrentRow = null;
		},
		submitRelateWatch() {
			if (!this.relateWatchCurrentRow) {
				return;
			}
			this.relateWatchLoading = true;
			this.relateWatchError = '';
			this.$post(
				'/api/radarWatch/radarWatch',
				{
					radarId: this.relateWatchCurrentRow.id,
					watchRelStatus: this.relateWatchType == 2 ? 1 : 2,
					watchSnCode: this.relateWatchValue,
				},
				(res) => {
					if (res.code == 0) {
						this.$message.success(res.msg || '操作成功');
						this.closeRelateWatchDialog();
						this.getTableData();
					} else {
						this.relateWatchError = res.msg || '操作失败';
						this.relateWatchLoading = false;
					}
				},
				(err) => {
					console.log(err);
					this.relateWatchError = err.msg || '服务端发生异常';
					this.relateWatchLoading = false;
				}
			);
		},

		// 点击出生日期，弹出日历组件
		cliBirthTan(wcIndex) {
			console.log('点击了出生日期');
			this.nowOper_birth_index = wcIndex;
			console.log('点击了第' + wcIndex + '项');
			if (!this.showBirthday) {
				this.showBirthday = true;
			}

			let date = new Date();
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var day = date.getDate();
			month = month > 9 ? month : '0' + month;
			day = day < 10 ? '0' + day : day;
			var today = year + '-' + month + '-' + day;
			console.log(today);
			today = '1950-01-01';
			if (!this.inputForm[wcIndex].birthday) {
				this.inputForm[wcIndex].birthday = today;
			}
		},
		// 点击某一天
		changeDate(date) {
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = '0' + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = '0' + d;
			var ad = y + '-' + m + '-' + d;
			console.log(ad);
			this.activeDate = ad;

			let wcIndex = this.nowOper_birth_index;
			this.inputForm[wcIndex].birthday = ad;
			this.showBirthday = false;
		},
		// 点击年月
		panelChange(date) {
			console.log(date);
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = '0' + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = '0' + d;
			var ad = y + '-' + m + '-' + d;
			console.log(ad);

			let wcIndex = this.nowOper_birth_index;
			this.inputForm[wcIndex].birthday = ad;
			this.$forceUpdate();
		},
		// 出生日期点击叉子
		clickBirChazi() {
			console.log(243332423);
			console.log(this.inputForm);
			let wcIndex = this.nowOper_birth_index;
			this.inputForm[wcIndex].birthday = null;
			this.$forceUpdate();
		},


		// 点击刷新
		clc_refresh(scope) {
			this.$get(
				'/api/4g/expirationDate',
				{
					cardMerchant: scope.cardMerchant,
					iccId: scope.iccId,
					id: scope.id
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							console.log(res)
							for (let i = 0; i < this.tableData.length; i++) {
								if (this.tableData[i].id == scope.id) {
									if (this.tableData[i].expirationDate == res.data.expirationDate) {      //如果相等说明没续费，直接retrun
										console.log('到期时间相等，不作操作')
										return;
									} else {     //到期时间不相等
										console.log('到期时间不相等')
										this.tableData[i].expirationDate = res.data.expirationDate;
										this.tableData[i].expirationDateStatus = res.data.expirationDateStatus;
									}
								}
							}
						} else {

						}
					} else {
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		// 点击续费
		cli_xfBtn(scope) {
			console.log(scope)
			for (let i = 0; i < this.tableData.length; i++) {
				if (scope.id == this.tableData[i].id) {
					this.tableData[i].isRefreshShow = true;   //刷新按钮是否显示
				}
			}

			this.cardMerchant = scope.cardMerchant;
			this.iccId = scope.iccId;
			this.rechargeQrcode();    //充值二维码接口
		},
		// 充值二维码接口
		rechargeQrcode() {
			this.$get(
				'/api/4g/rechargeQrcode',
				{
					cardMerchant: this.cardMerchant,
					iccId: this.iccId,
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.qrCode_baseUrl = res.data
							console.log(this.qrCode_baseUrl)
						} else {

						}
					} else {
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		oneKeyClearBtnClick(item) {
			this.isShowOneKeyClearAlert = true;
			this.currentOneKeyClearModel = item;
		},
		oneKeyClearClick() {
			this.$post(
					'/api/v3/radar/oneClickClear',
					{
						snCode: this.currentOneKeyClearModel.snCodeValue
					},
					(res) => {
						if (res.code == 0) {
							this.$message.success(res.msg || '清空成功');
							this.isShowOneKeyClearAlert = false;
						} else {
							this.$message.error(res.msg || '清空失败');
							this.isShowOneKeyClearAlert = false;
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
						this.isShowOneKeyClearAlert = false;
					}
				);
		}
	},
};
</script>
<style lang="scss">
.xfWrap {
	width: 305px;
	height: 382px;
	padding: 0 20px;
	box-sizing: border-box;
	background: #FFFFFF;
	box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
	border-radius: 16px;
	border: 3px solid rgba(255, 255, 255, 0.9);

	.xfTit {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 32px;
		padding-top: 20px;
	}

	.xfQrWrap {
		width: 135px;
		height: 135px;
		border-radius: 12px;
		border: 2px solid #C8E4FF;
		margin: 20px auto 0;

		.xfQrImg {
			width: 100%;
			height: 100%;
			display: block;
			border-radius: 12px;
		}
	}

	.xfTipWrap {
		display: flex;
		text-align: left;

		.xfPointBlue {
			width: 8px;
			height: 8px;
			background: #C8E4FF;
			border-radius: 50%;
			margin-top: 7px;
		}

		.xfTipsBlue {
			font-size: 16px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #348FE3;
			line-height: 22px;
			margin-left: 8px;
		}
	}

	.xfTipTwo {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 17px;
		margin-top: 5px;
		margin-left: 14px;
		display: flex;
	}

	.xfLine {
		width: 263px;
		height: 1px;
		background: #5E6779;
		opacity: 0.1;
		margin-top: 10px;
	}

	.qrDaSanJiao {
		width: 62px;
		height: 37px;
		position: absolute;
		top: -20px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.main::v-deep {
	padding: 0 !important;

	.topButton {
		margin-bottom: 10px;

		.ant-btn {
			margin-right: 10px;
		}

		.aBtFocus:focus {
			color: rgba(0, 0, 0, 0.65) !important;
			border-color: #d9d9d9 !important;
		}
	}

	.ant-table-tbody {
		min-height: 1134px;

		.ant-table-row:nth-child(even) {
			background: #f0f0f0;
		}
	}

	.ant-table-content {
		min-height: 1134px;
	}

	.ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
	.ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
	.ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
	.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
		background: none;
	}

	.ant-table-thead>tr>th {
		background: #f0f0f0;
	}

	.radarData {
		display: flex;
		align-items: center;

		span {
			flex: 1;
			color: #262626;
		}

		.tableImg {
			width: 18px;
			height: 20px;
			cursor: pointer;
			background: url('../../assets/icon_trashCan_nor.png') no-repeat center;
		}

		.tableImg:hover {
			background: url('../../assets/icon_trashCan_ove.png') no-repeat center;
		}
	}

	.bedData {

		//position: relative;
		input::-ms-input-placeholder {
			text-align: center;
		}

		input::-webkit-input-placeholder {
			text-align: center;
		}
	}

	.bedData:hover {
		.ant-input {
			border-color: #40a9ff;
		}

		.ant-cascader-picker {
			background: #e6f7ff;
		}

		.ant-cascader-picker-clear {
			background: #e6f7ff;
			color: #1890ff;
		}
	}

	.fourG_tr {
		display: flex;
		align-items: center;
		justify-content: center;

		.dqTime {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #262626;
			position: relative;
		}

		.icon_notice_dImg {
			width: 14px;
			height: 14px;
			display: block;
			margin-right: 5px;
		}

		.dqRefresh {
			width: 44px;
			height: 21px;
			line-height: 21px;
			background: #E7F3FF;
			border-radius: 14px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #1890FF;
			cursor: pointer;
			margin-left: 10px;
		}
	}
}

// 隐藏年月右上角
::v-deep .ant-fullcalendar-header .ant-radio-group {
	display: none !important;
}

.mainSearch {
	margin-top: 20px;
	padding: 20px !important;
	background: #fff;
}

.radarTitle {
	color: #595959;
	font-size: 14px;
}

.inputBox {
	display: flex;
}

.radarBtn {
	text-align: right;
	margin-top: 30px;

	.ant-btn {
		border-radius: 2px;
	}
}

.watchRelateModal {
	margin-top: -5px;

	.watchRelateLabel {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #262626;
		line-height: 20px;
		margin-bottom: 8px;
	}

	.watchRelateError {
		min-height: 22px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #FF4D4F;
		line-height: 22px;
		margin-top: 2px;
		margin-bottom: -24px;
	}

	.watchRelateFooter {
		text-align: right;
		margin-top: 20px;

		.ant-btn {
			min-width: 60px;
			height: 32px;
			border-radius: 2px;
		}

		.ant-btn + .ant-btn {
			margin-left: 10px;
		}
	}
}

.relateWCModal {
	padding-bottom: 0;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper {
	padding: 0 0px;
	border-radius: 2px;
	box-shadow: none;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper .ant-input {
	height: 32px;
	padding: 0;
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #262626;
	line-height: 22px;
	padding-left: 12px;
	padding-right: 12px;
	box-shadow: none;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper .ant-input::placeholder {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: rgba(0, 0, 0, 0.25);
	line-height: 22px;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper .ant-input::-webkit-input-placeholder {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: rgba(0, 0, 0, 0.25);
	line-height: 22px;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper .ant-input::-moz-placeholder {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: rgba(0, 0, 0, 0.25);
	line-height: 22px;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper .ant-input:-ms-input-placeholder {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: rgba(0, 0, 0, 0.25);
	line-height: 22px;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper .ant-input-suffix {
	top: 16px;
	right: 13px;
}

::v-deep .watchRelateInput.ant-input-affix-wrapper .ant-input-clear-icon {
	font-size: 18px;
	color: #bfbfbf;
}

::v-deep .watchRelateInputError.ant-input-affix-wrapper,
::v-deep .watchRelateInputError.ant-input-affix-wrapper:hover,
::v-deep .watchRelateInputError.ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
	border-color: #ff4d4f;
	box-shadow: none;
}

::v-deep .watchRelateInputError.ant-input-affix-wrapper .ant-input {
	color: #ff4d4f;
	border-color: rgba(255, 77, 79, 1);
}

.radarType {
	display: flex;
	align-items: center;
	margin-top: 30px;

	.btTitle {
		margin-right: 10px;
	}
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
	margin: 0;
}

.code-input-main {
	display: flex;
	flex-direction: row;
	justify-content: center;
	position: relative;
}

.code-input-input {
	height: 22px;
	width: 100%;
	position: absolute;
	border: none;
	outline: none;
	color: transparent;
	background-color: transparent;
	text-shadow: 0 0 0 transparent;
}

.code-input-main-item {
	width: 10px;
	height: 22px;
	margin: 0 5px;
	padding-bottom: 0;
	opacity: 0.8;
	border-bottom: solid #323232 1px;
	text-align: center;
	font-size: 16px;
	color: #323232;
	font-weight: bold;
	position: relative;
	display: flex;
	align-items: center;

	span {
		left: 18px;
		position: absolute;
		display: block;
		width: 10px;
		height: 2px;
		background: #262626;
	}
}

.delTips {
	.anticon {
		color: #faad14;
		margin-right: 10px;
	}
}

.delBtn {
	text-align: right;

	.ant-btn {
		height: 24px;
		line-height: 24px;
		border-radius: 2px;
		text-align: center;
		font-size: 14px;
	}
}

table {
	border-color: #f0f0f0;
	table-layout: fixed;
	/* font-size: 15px; */
}

tr {
	height: 60px;
}

td:nth-child(even) {}

td:nth-child(odd) {
	width: 100px;
	background: #980f0f;
	// font-weight: 800;
	text-align: center;
}

.form-item {
	position: relative;
	top: 12px;
	padding: 0 10px 0 10px;
}

.tableText {
	padding-left: 25px;
}

// 设置部分
.sxTipRed {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ff4d4f;
	line-height: 40px;
}

.setFoData {
	// width: 730px;
	border: 1px solid #f0f0f0;
	box-sizing: border-box;
}

.setFoData:nth-of-type(1) {
	margin-top: 0;
}

.setFoData .slist {
	height: 40px;
	background: #f0f0f0;
	border-bottom: 1px solid #f0f0f0;
	display: flex;
}

.setFoData .slist:nth-of-type(5) {
	border-bottom: 0;
}

.setFoData .slist .leftTit {
	width: 82px;
	line-height: 40px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #262626;
	text-align: center;
	position: relative;
}

.setFoData .slist .leftTit2 {
	width: 96px;
}

.setFoData .slist .btWrap {
	width: 156px;
	height: 100%;
	background: #fff;
	box-sizing: border-box;
	padding-left: 20px;
	display: flex;
	align-items: center;
}

.setFoData .slist .bbWrap {
	align-items: center;
	display: flex;
}

.setFoData .slist .bbWrap .input1 {
	width: 55px;
	height: 32px;
	border-radius: 2px;
	border: 1px solid #bfbfbf;
	outline: 0;
	padding-left: 12px;
	padding-right: 12px;
	box-sizing: border-box;
}

.setFoData .slist .bbWrap .input1Red {
	border: 1px solid #ff4d4f;
}

.setFoData .slist .bbWrap .p1 {
	line-height: 40px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #262626;
	margin-left: 12px;
}

::v-deep .el-switch .el-switch__core {
	widows: 42px !important;
	height: 22px !important;
}

::v-deep .el-switch__label {
	position: absolute;
	display: none;
	font-size: 12px !important;
	color: #fff !important;
}

::v-deep .el-switch__label * {
	font-size: 12px !important;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
	z-index: 1;
	left: -3px; // 这里是重点
	top: 0px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
	z-index: 1;
	left: 23px; // 这里是重点
	top: 0px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
	display: block;
}

::v-deep .el-switch__core {
	width: 45px;
	height: 22px;
	border: 2px solid #dcdfe6;
	border-radius: 13px;
}

.imgIconTK {
	width: 18px;
	height: 18px;
}

.upFileWrap {
	width: 350px;
	height: 33px;
	line-height: 33px;
	border: 1px solid #d9d9d9;
	display: flex;
	padding-left: 10px;
}

.fileLeftPath {
	margin-right: auto;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.sczIng {
	width: 74px;
	height: auto;
	background: #ffffff;
	border-radius: 2px;
	text-align: center;
	border-left: 1px solid #d9d9d9;
}

.xjDataWrap {
	line-height: 25px;
}

.aBtWrap {
	margin-top: 10px;
	text-align: right;
}

.ant-form-item {
	margin-bottom: 0;
}

// 隐藏上传时插件自带的列表
::v-deep .ant-upload-list {
	display: none;
}

.tableWrap {
	.ant-btn {
		padding: 0 5px;
	}
}

.lrck_tableWrap {
	padding-top: 30px;
	border-top: 2px dashed #d8d8d8;
	margin-top: 30px;
}

.noCanLrTip:hover .noCanLr {
	display: block;
}

.noCanLr {
	width: 153px;
	height: auto;
	padding: 9px;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 4px;
	border: 1px solid #1890ff;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #8c8c8c;
	word-wrap: break-word;
	white-space: normal;
	box-sizing: border-box;
	text-align: left;
	z-index: 9999;

	position: absolute;
	// position: relative;
	left: 10px;
	top: 25px;
	display: none;
}

.noCanLr:hover {
	display: block;
}

::v-deep .ant-calendar-picker-input {
	font-size: 14px;
}

::v-deep .ant-modal-body {
	background: #FFFFFF;
}
</style>
